
import axios, { all } from 'axios';
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import CustomDropdown from '../Dropdown/TableCustomeDropdown';
import { RiMenuSearchLine } from "react-icons/ri";
import toast from 'react-hot-toast';
import CreateLedger from '../../../Pages/TypesAndGroups/Ladgers/CreateLadger';
import FilterModal from '../Modals/FilterationModal';
import { useContext } from 'react';
import { CommonContext } from '../../../App';
import { useTranslation } from 'react-i18next';
import ContactMarquee from './ContactMarquee';
import { IoMdSettings } from "react-icons/io";
import TableFilterModal from '../Modals/ShowTableFilterModal';
import { FaChevronDown } from 'react-icons/fa';
import AddPayment from '../../../Pages/setting/PaymentStructure/AddPayment';
import api from '../../../services/api';
import { createPortal } from 'react-dom';
import { useLedgerSearch } from './useLedgerSearch';

const TableComponent = ({
    columns,
    allLedgers, setAllLedgers, allPaymentData, setAllpaymentData, updatePaymentAccount, ledgerData, setLedgerData, allGroups, allSubGroups, setAllGroups, setAllSubGroups, onUpdateData, heading, tableUniqueId, onDataChange, resetTrigger,
    allowMultiple, suggestionsData = [], firstInputPlaceholder, finalData = [], calculateTotal = false, perQuantityRate, changeDesignHeading, part, onCreateLedger, field, initialData = [], excludeFields = [], lockedFields = null, isMasterTable = false, onItemChange = null, syncedItem = '', syncedQuantity = '', syncedUnit = "", syncedUnitId = "",
    syncedRate = '', syncedItemInOut = '', syncedTotal = '', syncedPerQuantity = '', defaultLedgerGroup = '', columnLedgerGroups = {}, areaBasedRate = null, autoFillRate = false, onAreaDataChange = null, uniqueForFilter,
    tableFilteration, tableFilterModalOpen, setTableFilterModalOpen, tableFilters, setTableFilters, createDyanamicAccount, onAddNewPayment = null, showValidationError, isSettingDataRef, skipItemValidation = false,
    isEditMode
}) => {
    const createEmptyRow = useCallback((exclude = []) => {
        const initial = {};
        columns.forEach(col => {
            if (!exclude.includes(col.placeholder)) {
                initial[col.placeholder] = '';
            }
        });
        return initial;
    }, [columns]);

    const safeIsSettingRef = isSettingDataRef ?? { current: false };

    const API_BASE = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        if (safeIsSettingRef.current) return;

        if (!isMasterTable && (syncedItem || syncedQuantity || syncedUnit || syncedItemInOut || syncedRate || syncedTotal || syncedPerQuantity || syncedUnitId)) {
            setRows(prevRows => {
                if (prevRows.length === 0) return prevRows;

                return prevRows.map((row, index) => {
                    if (index === 0) {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                typeOfBricks: syncedItem || row.data.typeOfBricks || '',
                                items: syncedItem || row.data.items || '',
                                quantity: !isEditMode ? syncedQuantity : row.data.quantity,
                                unit: syncedUnit || row.data.unit || '',
                                unitId: syncedUnitId || row.data.unitId || '',
                                itemInOut: syncedItemInOut || row.data.itemInOut || '',
                                rate: syncedRate || row.data.rate || '',
                                total: syncedTotal || row.data.total || '',
                                perQuantity: syncedPerQuantity || row.data.perQuantity || row.data.per_quantity || ''
                            }
                        };
                    } else {
                        if (isEditMode) return row;

                        return {
                            ...row,
                            data: {
                                ...row.data,
                                typeOfBricks: syncedItem || row.data.typeOfBricks || '',
                                items: syncedItem || row.data.items || '',
                                quantity: '0',
                                unit: syncedUnit || row.data.unit || '',
                                unitId: syncedUnitId || row.data.unitId || '',
                                itemInOut: syncedItemInOut || row.data.itemInOut || '',
                                rate: syncedRate || row.data.rate || '',
                                total: syncedTotal || row.data.total || '',
                                perQuantity: syncedPerQuantity || row.data.perQuantity || row.data.per_quantity || ''
                            }
                        };
                    }
                });
            });
        }
    }, [syncedItem, syncedQuantity, syncedUnit, isMasterTable, syncedItemInOut, syncedRate, syncedTotal, syncedPerQuantity, syncedUnitId, isEditMode]);

    const [rows, setRows] = useState([{
        id: (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`),
        data: createEmptyRow()
    }]);
    const [suggestionsVisibleFor, setSuggestionsVisibleFor] = useState(null);
    const [filteredSuggestionsByRow, setFilteredSuggestionsByRow] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [modalPlaceholder, setModalPlaceholder] = useState(null);
    const [newOptionText, setNewOptionText] = useState('');
    const [openDropdown, setOpenDropdown] = useState(null);
    const wrapperRef = useRef(null);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [selectedSubGroups, setSelectedSubGroups] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [addFilterationValue, setAddFilterationValue] = useState(false);
    const [highlightIndexes, setHighlightIndexes] = useState({});
    const [keyboardHighlightIndexes, setKeyboardHighlightIndexes] = useState({});
    const [uniqueFilter, setUniqueFilter] = useState('');
    const [columnUniqueId, setColumnUniqueId] = useState('');
    const [fetchDatabyFilter, setFetchDatabyFilter] = useState('');
    const [allowedGroupTypes, setAllowedGroupTypes] = useState([]);
    const suggestionRefs = useRef({});
    const { branchId } = useContext(CommonContext)
    const { t, } = useTranslation();
    const [createLedgerInitData, setCreateLedgerInitData] = useState(null);
    const suggestionWrapperRef = useRef(null);
    const firstInputRef = useRef(null);
    const [selectedUnit, setSelectedUnit] = useState(() => {
        return localStorage.getItem(`${heading}_${part || "part"}_selectedUnit`) || "";
    });
    const [isModalOpenRateUnit, setIsModalOpenRateUnit] = useState(false);

    const [isAddPaymentModalOpen, setIsAddPaymentModalOpen] = useState(false);
    const [paymentName, setPaymentName] = useState("");
    const [paymentNameInHindi, setPaymentNameInHindi] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [paymentGroupName, setPaymentGroupName] = useState("");
    const [paymentGroupId, setPaymentGroupId] = useState("");
    const [paymentGroupType, setPaymentGroupType] = useState("");
    const [paymentSubGroup, setPaymentSubGroup] = useState("");
    const [paymentLedger, setPaymentLedger] = useState("");
    const [paymentTypeValidation, setPaymentTypeValidation] = useState(false);
    const [paymentSubGroupValidation, setPaymentSubGroupValidation] = useState(false);
    const [paymentSelectGroupValidation, setPaymentSelectGroupValidation] = useState(false);
    const [filtersLoaded, setFiltersLoaded] = useState(false);
    const [showLedgerData, setShowLedgerData] = useState([]);
    const [paymentSubGroupId, setPaymentSubGroupId] = useState("");
    const [paymentLedgerId, setPaymentLedgerId] = useState("");
    const [ledgerFilterVersion, setLedgerFilterVersion] = useState(0);
    const [suggestionPosition, setSuggestionPosition] = useState({
        top: 0, left: 0, width: 0,
        isInModal: false
    });
    const [activeGroupIds, setActiveGroupIds] = useState([]);
    const [activeSubGroupIds, setActiveSubGroupIds] = useState([]);
    const [filterInserted, setFilterInserted] = useState(false);
    const [dynamicAccountDropdownOpen, setDynamicAccountDropdownOpen] = useState(false);
    const [selectedDynamicAccount, setSelectedDynamicAccount] = useState(() => {
        const saved = localStorage.getItem(`dynamicAccount_${heading}`);

        return saved ? JSON.parse(saved) : null;
    });

    const [currentSearchValue, setCurrentSearchValue] = useState('');
    const [columnFilterMap, setColumnFilterMap] = useState({});
    const { results: backendLedgers, loading: ledgerSearchLoading } = useLedgerSearch({
        searchValue: currentSearchValue,
        branchId,
        enabled: !!currentSearchValue,
        activeGroupIds,
        activeSubGroupIds,
    });

    const dynamicAccountRef = useRef(null);
    const tableContainerRef = useRef(null);
    const lastFocusedElementRef = useRef(null);
    const [hoverIndex, setHoverIndex] = useState({});
    useEffect(() => {
        if (allLedgers && allLedgers.length > 0) {
            setShowLedgerData(allLedgers);
        }
    }, [allLedgers]);

    const handlePaymentDataRefresh = (refreshData) => {
        if (refreshData.type === 'subgroupSelected') {
            setPaymentSubGroupId(refreshData.data.id);
        } else if (refreshData.type === 'ledgerSelected') {
            setPaymentLedgerId(refreshData.data.id);
        }
    };

    const [filterVersion, setFilterVersion] = useState(0);

    const handleFilterUpdate = useCallback(() => {
        setFilterVersion(v => v + 1);
    }, []);

    const defaultPaymentType = useMemo(() => {
        return allPaymentData?.find(p => p.is_default === 1) || null;
    }, [allPaymentData]);

    const getDynamicAccountOptions = useMemo(() => {
        if (!showLedgerData || showLedgerData.length === 0) return [];

        return showLedgerData.map(ledger => ({
            id: ledger.id || ledger.ledger_id,
            name: ledger.name,
            nameInHindi: ledger.nameInHindi,
            phone: ledger.phone,
            address: ledger.address,
            groupName: ledger.groupName,
            subGroupName: ledger.subGroupName,
            type: 'ledger'
        }));
    }, [showLedgerData]);

    const handleDynamicAccountSelect = useCallback((option) => {
        setSelectedDynamicAccount(option);
        localStorage.setItem(`dynamicAccount_${heading}`, JSON.stringify(option));
        setDynamicAccountDropdownOpen(false);
    }, [heading]);

    const defaultDynamicAccount = useMemo(() => {
        return getDynamicAccountOptions[0] || null;
    }, [getDynamicAccountOptions]);

    useEffect(() => {
        if (!selectedDynamicAccount && defaultDynamicAccount) {
            setSelectedDynamicAccount(defaultDynamicAccount);
            localStorage.setItem(`dynamicAccount_${heading}`, JSON.stringify(defaultDynamicAccount));
        }
    }, [selectedDynamicAccount, defaultDynamicAccount, heading]);

    const norm = v => (v?.toString().trim().toLowerCase() || '');
    const keyNP = (nameField, phone) => `${norm(nameField)}|${norm(phone)}`;

    const normalizedLockedFields = useMemo(() => {
        if (!lockedFields) return null;
        return {
            ledgerId: lockedFields.ledgerId ?? lockedFields.ledger_id ?? '',
            ledgerGroup: lockedFields.ledgerGroupId ?? lockedFields.ledger_group_id ?? '',
            ledgerSubGroup: lockedFields.ledgerSubGroupId ?? lockedFields.ledger_sub_group_id ?? '',
            ...lockedFields
        };
    }, [lockedFields]);

    const groupedData = useMemo(() => {
        if (!allGroups || !allSubGroups) return [];

        return allGroups
            .filter(group =>
                allowedGroupTypes.length === 0 ||
                allowedGroupTypes.includes(group.type)
            )
            .map(group => ({
                ...group,
                subGroups: allSubGroups
                    .filter(sg => sg.groupName === group.groupName)
                    .map(sg => ({
                        subGroupName: sg.subGroupName,
                        subGroupNameInHindi: sg.subGroupNameInHindi,
                        subGroupId: sg.id || sg.subGroupId  // ← yeh add karo
                    }))
            }));
    }, [allGroups, allSubGroups, allowedGroupTypes]);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        function handleOutsideClick(e) {
            if (
                suggestionWrapperRef.current &&
                !suggestionWrapperRef.current.contains(e.target)
            ) {
                setSuggestionsVisibleFor(null);
            }

            if (
                dynamicAccountRef.current &&
                !dynamicAccountRef.current.contains(e.target)
            ) {
                setDynamicAccountDropdownOpen(false);
            }
        }

        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, []);

    useEffect(() => {
        setRows([{
            id: (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`),
            data: createEmptyRow()
        }]);
    }, [resetTrigger]);

    useEffect(() => {
        if (!initialData || initialData.length === 0) return;

        const normalized = initialData.map((row, index) => ({
            id: row.id ?? index,
            data: {
                ...Object.keys(row).reduce((acc, key) => {
                    const value = row[key];
                    acc[key] = typeof value === 'object' && value?.name ? value.name : value ?? "";
                    return acc;
                }, {}),
                customerName: row.customer_name ?? "",
                vendor: row.vendor ?? "",
                address: row.address ?? "",
                phone: row.phone ?? "",
                typeOfBricks: row.typeOfBricks ?? "",
                items: row.items ?? "",
                quantity: row.quantity ?? "",
                rate: row.rate ?? "",
                unit: row.unit ?? "",
                unitId: row.unitId ?? "",
                total: row.total ?? "",
                paymentType: row.paymentType ?? "",
                received: row.received ?? "",
                name: row.name ?? "",
                paid: row.paid ?? "",
                part: row.part ?? "",
                ledgerGroup: row.ledger_group_id ?? row.ledgerGroupId ?? '',
                ledgerSubGroup: row.ledger_sub_group_id ?? row.ledgerSubGroupId ?? '',
                ledgerSubGroupName: row.sub_group_name ?? row.ledgerSubGroupName ?? '',
                ledgerType: row.groupType,
                ledgerId: row.ledger_id ?? row.ledgerId ?? '',
                entry_id: row.entry_id ?? '',
                itemInOut: row.item_in_out ?? '',
                perQuantity: row.per_quantity ?? '',
                areaId: row.areaId ?? '',
                areaName: row.areaName ?? '',
                areaPrice: row.areaPrice ?? '',
                _originalTotal: row.total,
                _isFromDatabase: true,
            }
        }));

        setRows(prevRows => {
            const isSame = JSON.stringify(prevRows) === JSON.stringify(normalized);
            return isSame ? prevRows : normalized;
        });
    }, [initialData?.length, resetTrigger]);

    const normalize = (v) => v?.toString().trim().toLowerCase();

    useEffect(() => {
        if (allLedgers.length > 0) {
        }
    }, [allLedgers]);
    const fetchActiveFilterIds = useCallback(async () => {
        if (!branchId || !tableUniqueId || !columnUniqueId) return;
        try {
            const res = await api.get('/column-filter/get-filter-value', {
                params: {
                    branchId,
                    tableName: tableUniqueId,
                    columnName: columnUniqueId
                }
            });
            const data = res?.data?.data;
            if (data) {
                setActiveGroupIds(data.groupIds || []);
                setActiveSubGroupIds(data.subGroupIds || []);
            } else {
                setActiveGroupIds([]);
                setActiveSubGroupIds([]);
            }
        } catch (err) {
            console.error('[TableComponent] fetchActiveFilterIds error:', err);
            setActiveGroupIds([]);
            setActiveSubGroupIds([]);
        }
    }, [branchId, tableUniqueId, columnUniqueId]);
    useEffect(() => {
        if (!branchId || !tableUniqueId || !columnUniqueId) {
            setFiltersLoaded(true);
            return;
        }
        fetchActiveFilterIds().finally(() => setFiltersLoaded(true));
    }, [branchId, tableUniqueId, columnUniqueId, filterVersion, fetchActiveFilterIds]);

    const filterData = useCallback(() => {
        if (!allLedgers || allLedgers.length === 0) return [];
        if (activeGroupIds.length === 0 && activeSubGroupIds.length === 0) return allLedgers;
        const activeGroupNames = new Set(
            allGroups
                .filter(g => activeGroupIds.includes(g.id || g.groupId))
                .map(g => normalize(g.groupName))
        );
        const activeSubGroupNames = new Set(
            allSubGroups
                .filter(sg => activeSubGroupIds.includes(sg.id || sg.subGroupId))
                .map(sg => normalize(sg.subGroupName))
        );

        return allLedgers.filter(l => {
            const gName = normalize(l.groupName || l.group_name);
            const sgName = normalize(l.subGroupName || l.sub_group_name);
            return (
                (activeGroupNames.size > 0 && activeGroupNames.has(gName)) ||
                (activeSubGroupNames.size > 0 && activeSubGroupNames.has(sgName))
            );
        });
    }, [allLedgers, allGroups, allSubGroups, activeGroupIds, activeSubGroupIds, filterVersion]);

    useEffect(() => {
        const result = filterData();
        setLedgerData(result);
        setShowLedgerData(result);
    }, [filterData]);

    useEffect(() => {
        if (!allLedgers || allLedgers.length === 0) {
            setLedgerData([]);
            setShowLedgerData([]);
            return;
        }
        filterData();
    }, [filtersLoaded, allLedgers, filterData, heading]);

    useEffect(() => {
        if (!filtersLoaded) return;

        if (!isModalOpen && allLedgers && allLedgers.length > 0) {
            filterData();
        }
    }, [isModalOpen, allLedgers, filtersLoaded, filterData, heading]);

    useEffect(() => {
        const filteredRows = rows.map(row => {
            const filteredData = {};

            columns.forEach(col => {
                filteredData[col.placeholder] = row.data[col.placeholder] ?? '';
            });

            if (!filteredData.paymentType && defaultPaymentType) {
                filteredData.paymentType = {
                    id: defaultPaymentType.ledgerId,
                    name: defaultPaymentType.name
                };
            }

            if (row.data.ledgerId) filteredData.ledgerId = row.data.ledgerId;
            if (row.data.ledgerGroup) filteredData.ledgerGroup = row.data.ledgerGroup;
            if (row.data.ledgerSubGroup) filteredData.ledgerSubGroup = row.data.ledgerSubGroup;
            if (row.data.ledgerType) filteredData.ledgerType = row.data.ledgerType;
            if (row.data.id) filteredData.id = row.data.id;
            if (row.data.entry_id) filteredData.entry_id = row.data.entry_id;
            if (row.data.areaId) filteredData.areaId = row.data.areaId;
            if (row.data.areaName) filteredData.areaName = row.data.areaName;
            if (row.data.areaPrice) filteredData.areaPrice = row.data.areaPrice;
            if (row.data.area) filteredData.area = row.data.area;
            if (row.data.transportationRate) filteredData.transportationRate = row.data.transportationRate;
            if (row.data.cousinName) filteredData.cousinName = row.data.cousinName;
            if (row.data.per_quantity) filteredData.per_quantity = row.data.per_quantity;
            if (row.data.unit) filteredData.unit = row.data.unit;
            if (isEditMode && row.data.frontendDelete === 0) {
                filteredData.frontendDelete = 0;
            }

            if (selectedDynamicAccount) {
                filteredData.dynamicAccountId = selectedDynamicAccount.id;
                filteredData.dynamicAccountName = selectedDynamicAccount.name;
                filteredData.dynamicAccountType = selectedDynamicAccount.type;
            }

            return filteredData;
        });
        onDataChange(filteredRows);
    }, [rows, defaultPaymentType, isEditMode]);

    const getFieldValue = useCallback((item) => {
        return (
            item?.[field] ||
            item?.customerName ||
            item?.name ||
            item?.vehicleName ||
            item?.companyName ||
            item?.vendor ||
            item?.driverName ||
            ""
        );
    }, [field]);

    const updateSuggestionsFor = useCallback((rowId, valueOrObj) => {
        const rawValue = (typeof valueOrObj === 'object' && valueOrObj !== null)
            ? (valueOrObj.name || valueOrObj[firstInputPlaceholder] || '')
            : (valueOrObj ?? '');

        if (!rawValue.trim()) {
            setSuggestionsVisibleFor(null);
            return;
        }

        // Sirf API ko trigger karo
        setCurrentSearchValue(rawValue);
        setSuggestionsVisibleFor(rowId);
    }, [firstInputPlaceholder]);

    const triggerCreateLedger = useCallback((payload, sourceField = firstInputPlaceholder, targetRowId = null) => {
        lastFocusedElementRef.current = document.activeElement;

        if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
        }

        if (sourceField === firstInputPlaceholder && targetRowId) {
            setRows(prevRows =>
                prevRows.map(row => {
                    if (row.id === targetRowId) {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                [firstInputPlaceholder]: ''
                            }
                        };
                    }
                    return row;
                })
            );
        }

        let prepared = {};
        if (payload && typeof payload === 'object') {
            prepared = {
                name: payload[field] || payload.name || '',
                phone: payload.phone || '',
                address: payload.address || '',
                cousinName: payload.cousinName || '',
                ledgerSubGroupName: payload.ledgerSubGroupName || "",
                ledgerSubGroupNameInHindi: payload.ledgerSubGroupNameInHindi || "",
                group: payload.group || (columnLedgerGroups[sourceField] || defaultLedgerGroup) || ''
            };
        } else {
            prepared = {
                name: payload || '',
                phone: '',
                address: '',
                cousinName: '',
                ledgerSubGroupName: "",
                ledgerSubGroupNameInHindi: "",
                group: (columnLedgerGroups[sourceField] || defaultLedgerGroup) || ''
            };
        }

        setCreateLedgerInitData(prepared);
        if (typeof onCreateLedger === "function") {
            onCreateLedger(prepared);
        }
        setModalVisible(true);

        setTimeout(() => {
            if (tableContainerRef.current) {
                tableContainerRef.current.style.filter = 'blur(0.3px)';
                tableContainerRef.current.style.pointerEvents = 'none';
            }
        }, 50);

    }, [onCreateLedger, field, firstInputPlaceholder, defaultLedgerGroup, columnLedgerGroups, setRows]);

    const handleInputChange = useCallback(
        (id, placeholder, value) => {
            const isInModal = document.querySelector('.fixed.inset-0.z-\\[999\\]');
            if (safeIsSettingRef.current) {
                setRows(prev =>
                    prev.map(r =>
                        r.id === id ? { ...r, data: { ...r.data, [placeholder]: value } } : r
                    )
                );
                return;
            }

            const column = columns.find(col => col.placeholder === placeholder);
            const rowIndex = rows.findIndex(r => r.id === id);
            if (rowIndex === -1) return;
            const isFirstInput = placeholder === firstInputPlaceholder;
            const isLocked = !!(column?.locked && normalizedLockedFields && rowIndex > 0);
            if (isLocked) return;
            if (isFirstInput && typeof value === 'string' && value.trim()) {
                if (isInModal) {
                    setTimeout(() => {
                        updateSuggestionsFor(id, value);
                    }, 150);
                } else {
                    updateSuggestionsFor(id, value);
                }
            } else if (isFirstInput) {
                setSuggestionsVisibleFor(null);
            }
            const currentRow = rows[rowIndex];

            const itemRelatedFields = ['typeOfBricks', 'items', 'customerName', 'name', 'vendor'];
            if (!skipItemValidation && !itemRelatedFields.includes(placeholder)) {
                const hasItemColumn = columns.some(
                    col => col.placeholder === 'typeOfBricks' || col.placeholder === 'items'
                );
                const itemValue = currentRow?.data?.typeOfBricks || currentRow?.data?.items;

                if (hasItemColumn && !itemValue) {
                    showValidationError?.('Please select items !');
                    return;
                }
            }

            const totalQuantityFromSales = parseFloat(syncedQuantity) || 0;
            const newQuantityEntered = parseFloat(value) || 0;

            if (!isMasterTable && placeholder === 'quantity') {
                if (!isEditMode && totalQuantityFromSales === 0) {
                    showValidationError?.('No quantity available from sales table!');
                    return;
                }

                if (!isEditMode && rowIndex === rows.filter(r => r.data.frontendDelete !== 0).length - 1) {
                    const usedByOthers = rows
                        .filter(r => r.data.frontendDelete !== 0)
                        .reduce((sum, r, i) => {
                            if (i !== rowIndex) sum += parseFloat(r?.data?.quantity) || 0;
                            return sum;
                        }, 0);

                    const available = totalQuantityFromSales - usedByOthers;
                    if (newQuantityEntered > available) {
                        showValidationError?.(`Cannot exceed available quantity! Maximum allowed: ${available}`);
                        return;
                    }
                }
            }

            const normalizeValue = val => {
                if (val && typeof val === 'object') {
                    return {
                        id: val.id,
                        name: val.name ?? val[placeholder] ?? '',
                        unit: val.unit || '',
                        unitId: val.unitId || '',
                        perQuantity: val.perQuantity || '',
                    };
                }
                return val;
            };

            const findLatestHistory = (partyName, itemName, field) => {
                let all = [];
                finalData.forEach(entry => {
                    // const allRecords = [...(entry.sales || []), ...(entry.purchase || []), ...(entry.loading || [])];
                    const allRecords = [
                        ...(entry.sales || []),
                        ...(entry.purchase || []),
                        ...(entry.loading || []),
                        ...(entry.fromJournal || []),   //  ADD
                        ...(entry.toJournal || []),     //  ADD
                    ];
                    const matched = allRecords.filter(record => {
                        const recordName = norm(
                            record?.customer_name || record?.customerName || record?.vendor || record?.name || ''
                        );
                        const recordItem = norm(
                            field === 'typeOfBricks'
                                ? record?.typeOfBricks?.name || record?.type_of_bricks || ''
                                : record?.items?.name || record?.items || ''
                        );
                        return recordName === partyName && recordItem === itemName;
                    });
                    if (matched.length) {
                        all.push(...matched.map(m => ({ ...m, created_at: new Date(m.created_at || m.createdAt) })));
                    }
                });

                if (!all.length) return null;
                return all.sort((a, b) => b.created_at - a.created_at)[0];
            };

            const normalizedValue = normalizeValue(value);

            const isClearing = isFirstInput && !value;

            setRows(prevRows => {
                const nextRows = [...prevRows];
                const row = nextRows[rowIndex];

                if (isClearing) {
                    setSuggestionsVisibleFor(null);
                    setFilteredSuggestionsByRow(prev => ({ ...prev, [id]: [] }));

                    const clearedData = { ...row.data };

                    const baseFieldsToClear = [
                        'phone',
                        'address',
                        'cousinName',
                        'ledgerSubGroupName',
                        'ledgerSubGroupNameInHindi',
                        'total',
                        'paymentType',
                        'areaId',
                        'areaName',
                        'area',
                        'areaPrice',
                        'transportationRate',
                        'ledgerId',
                        'ledgerGroup',
                        'ledgerSubGroup',
                        'ledgerType',
                        'balance',
                    ];

                    const editSensitiveFields = ['rate', 'unit', 'unitId', 'perQuantity'];

                    const fieldsToClear = isEditMode
                        ? baseFieldsToClear
                        : [...baseFieldsToClear, ...editSensitiveFields];

                    fieldsToClear.forEach(f => {
                        clearedData[f] = '';
                    });

                    nextRows[rowIndex] = {
                        ...row,
                        data: {
                            ...clearedData,
                            [placeholder]: ''
                        },
                    };

                    if (typeof onAreaDataChange === 'function') {
                        onAreaDataChange({
                            areaId: '',
                            areaName: '',
                            areaPrice: '',
                            transportationRate: ''
                        });
                    }

                    return nextRows;
                }

                let updatedData = {
                    ...row.data,
                    [placeholder]: normalizedValue,
                    ledgerId: row.data.ledgerId || normalizedLockedFields?.ledgerId || '',
                    ledgerGroup: row.data.ledgerGroup || normalizedLockedFields?.ledgerGroup || '',
                    ledgerSubGroup: row.data.ledgerSubGroup || normalizedLockedFields?.ledgerSubGroup || '',
                    ledgerSubGroupName:
                        row.data.ledgerSubGroupName || normalizedLockedFields?.ledgerSubGroupName || '',
                    ledgerSubGroupNameInHindi:
                        row.data.ledgerSubGroupNameInHindi ||
                        normalizedLockedFields?.ledgerSubGroupNameInHindi ||
                        '',
                };

                if (isFirstInput && typeof value === 'string' && value.trim()) {
                    updateSuggestionsFor(id, value);
                } else if (isFirstInput) {
                    setSuggestionsVisibleFor(null);
                }

                if (placeholder === 'typeOfBricks' || placeholder === 'items') {
                    const partyName = norm(
                        updatedData[firstInputPlaceholder]?.name?.toString() ||
                        updatedData[firstInputPlaceholder]?.toString() ||
                        ''
                    );
                    const itemName = norm(normalizedValue?.name?.toString() || normalizedValue?.toString() || '');

                    const shouldAutoFillRate = !heading?.toLowerCase().includes('transportation');
                    const latest = partyName && itemName
                        ? findLatestHistory(partyName, itemName, placeholder)
                        : null;

                    updatedData = {
                        ...updatedData,
                        [placeholder]: normalizedValue,
                        rate: latest && shouldAutoFillRate ? latest.rate || '' : shouldAutoFillRate ? '' : updatedData.rate,
                        unit: latest?.unit || normalizedValue.unit || updatedData.unit || '',
                        unitId: latest?.unitId || normalizedValue.unitId || updatedData.unitId || '',
                        perQuantity:
                            latest?.per_quantity ||
                            latest?.perQuantity ||
                            normalizedValue.perQuantity ||
                            updatedData.perQuantity ||
                            '',
                    };
                }

                if (calculateTotal && placeholder === 'total') {
                    const total = value === '' ? '' : value;
                    const quantity = parseFloat(currentRow?.data?.quantity) || 0;
                    const perQty = parseFloat(
                        currentRow?.data?.perQuantity ||
                        currentRow?.data?.per_quantity ||
                        syncedPerQuantity
                    ) || 1;

                    updatedData.total = total;
                    updatedData._totalModified = true;

                    if (total !== '' && quantity > 0) {
                        const numericTotal = parseFloat(total) || 0;
                        const calculatedRate = (numericTotal * perQty) / quantity;
                        updatedData.rate = calculatedRate.toFixed(2);
                    } else {
                        updatedData.rate = '';
                    }

                    nextRows[rowIndex] = { ...row, data: updatedData };
                    return nextRows;
                }

                if (placeholder === 'rate') updatedData._rateModified = true;
                if (placeholder === 'quantity') updatedData._quantityModified = true;

                if (
                    calculateTotal &&
                    (placeholder === 'rate' ||
                        placeholder === 'quantity' ||
                        placeholder === 'perQuantity' ||
                        placeholder === 'typeOfBricks' ||
                        placeholder === 'items')
                ) {
                    const rate = parseFloat(updatedData.rate) || 0;
                    const qty = parseFloat(updatedData.quantity) || 0;
                    const per =
                        parseFloat(
                            updatedData.perQuantity ||
                            updatedData.per_quantity ||
                            updatedData.typeOfBricks?.perQuantity ||
                            updatedData.items?.perQuantity
                        ) || 1;

                    updatedData.total = rate && qty ? (rate * qty) / per : '';
                }

                nextRows[rowIndex] = { ...row, data: updatedData };

                if (isMasterTable && rowIndex === 0 && onItemChange) {
                    if (['typeOfBricks', 'items', 'quantity'].includes(placeholder)) {
                        const currentItem =
                            placeholder === 'typeOfBricks' || placeholder === 'items'
                                ? normalizedValue
                                : updatedData.typeOfBricks || updatedData.items;
                        const currentQuantity =
                            placeholder === 'quantity' ? normalizedValue : updatedData.quantity;

                        onItemChange(
                            currentItem,
                            currentQuantity,
                            updatedData.unit,
                            updatedData.unitId,
                            updatedData.itemInOut,
                            updatedData.rate,
                            updatedData.total,
                            updatedData.perQuantity
                        );
                    }
                }

                if (!isMasterTable && placeholder === 'quantity') {
                    const total = totalQuantityFromSales;
                    let used = 0;
                    const activeRows = nextRows.filter(r => r.data.frontendDelete !== 0);

                    for (let i = 0; i < activeRows.length; i++) {
                        const r = activeRows[i];
                        if (!r?.data) continue;

                        if (i <= rowIndex) {
                            used += parseFloat(i === rowIndex ? newQuantityEntered : r.data.quantity) || 0;
                        } else {
                            const remaining = total - used;
                            const actualIndex = nextRows.findIndex(nr => nr.id === r.id);
                            nextRows[actualIndex] = {
                                ...r,
                                data: {
                                    ...r.data,
                                    quantity: i === rowIndex + 1 && remaining > 0 ? remaining.toString() : '0',
                                },
                            };
                        }
                    }
                }

                return nextRows;
            });
        },
        [
            columns,
            rows,
            isEditMode,
            syncedQuantity,
            normalizedLockedFields,
            firstInputPlaceholder,
            updateSuggestionsFor,
            finalData,
            calculateTotal,
            isMasterTable,
            onItemChange,
            showValidationError,
            heading,
            norm,
            safeIsSettingRef,
            onAreaDataChange,
            syncedPerQuantity,
        ]
    );

    const fetchLatestEntry = useCallback(async (ledgerId) => {
        if (!ledgerId) return null;

        // heading ko lowercase aur trim karke match karo
        const headingLower = heading?.toLowerCase()?.trim() || '';

        let type = null;

        if (headingLower.includes('sale')) type = 'sales';
        else if (headingLower.includes('receive')) type = 'receipt';
        else if (headingLower.includes('pay')) type = 'payment';
        else if (headingLower.includes('purchase')) type = 'purchase';
        else if (headingLower.includes('from')) type = 'from';
        else if (headingLower.includes('to')) type = 'to';
        else if (headingLower.includes('loading/unloading')) type = 'loadingUnloading';
        else if (headingLower.includes('transportation')) type = 'transportation';

        if (!type) return null;  // type nahi mila to API mat maaro

        try {
            const res = await api.post('ledgers/fetch-latest-recoard', {
                ledgerId,
                branchId,
                type
            });

            if (res.data.success && res.data.data) {
                return res.data.data;
            }
            return null;
        } catch (err) {
            console.error('[fetchLatestEntry] error:', err);
            return null;
        }
    }, [heading, branchId]);

    const memoPaymentType = useMemo(() => {
        if (!defaultPaymentType) return null;

        return {
            id: defaultPaymentType.ledgerId,
            name: defaultPaymentType.name
        };
    }, [defaultPaymentType]);

    const applyRowUpdate = useCallback((rowId, cleanData) => {
        setRows((prevRows) =>
            prevRows.map((row) => {
                if (row.id !== rowId) return row;

                const updatedData = {
                    ...row.data,
                    ...cleanData,
                    balance: cleanData.balance || null,
                    typeOfBricks: cleanData.typeOfBricks ?? row.data.typeOfBricks ?? "",
                    unit: cleanData.unit || row.data.unit || syncedUnit || "",
                    unitId: cleanData.unitId || row.data.unitId || syncedUnitId || "",
                    items: cleanData.items ?? row.data.items ?? "",
                    vendor: cleanData.vendor ?? row.data.vendor ?? "",
                    paymentType: cleanData.paymentType ?? row.data.paymentType ?? "",
                    ledgerId: cleanData.ledgerId ?? row.data.ledgerId ?? normalizedLockedFields?.ledgerId ?? "",
                    ledgerGroup: cleanData.ledgerGroupId ?? row.data.ledgerGroupId ?? normalizedLockedFields?.ledgerGroup ?? "",
                    ledgerSubGroup: cleanData.ledgerSubGroupId ?? row.data.ledgerSubGroupId ?? normalizedLockedFields?.ledgerSubGroup ?? "",
                    ledgerSubGroupName: cleanData.ledgerSubGroupName ?? row.data.ledgerSubGroupName ?? normalizedLockedFields?.ledgerSubGroupName ?? "",
                    ledgerSubGroupNameInHindi: cleanData.ledgerSubGroupNameInHindi ?? row.data.ledgerSubGroupNameInHindi ?? normalizedLockedFields?.ledgerSubGroupNameInHindi ?? "",
                    ...(!isMasterTable && {
                        rate: (cleanData.rate && parseFloat(cleanData.rate) > 0) ? cleanData.rate : (row.data.rate || syncedRate || ""),
                        total: (cleanData.total && parseFloat(cleanData.total) > 0) ? cleanData.total : (row.data.total || syncedTotal || ""),
                        perQuantity: cleanData.perQuantity || row.data.perQuantity || syncedPerQuantity || "",
                        itemInOut: cleanData.itemInOut || row.data.itemInOut || syncedItemInOut || "",
                    }),
                };

                if (!isMasterTable) {
                    const rowIndex = prevRows.findIndex(r => r.id === rowId);
                    const hasMultipleRows = prevRows.filter(r => r.data.frontendDelete !== 0).length > 1;

                    if (hasMultipleRows && row.data.quantity) {
                        updatedData.quantity = row.data.quantity;
                        if (calculateTotal && updatedData.rate) {
                            const rate = parseFloat(updatedData.rate) || 0;
                            const quantity = parseFloat(row.data.quantity) || 0;
                            const perQty = parseFloat(updatedData.perQuantity) || 1;
                            updatedData.total = (rate * quantity) / perQty;
                        }
                    } else if (!row.data.quantity && rowIndex === 0 && syncedQuantity) {
                        updatedData.quantity = syncedQuantity;
                        if (calculateTotal && updatedData.rate) {
                            const rate = parseFloat(updatedData.rate) || 0;
                            const quantity = parseFloat(syncedQuantity) || 0;
                            const perQty = parseFloat(updatedData.perQuantity) || 1;
                            updatedData.total = (rate * quantity) / perQty;
                        }
                    } else if (!row.data.quantity && rowIndex > 0 && syncedQuantity && !isEditMode) {
                        const totalQuantity = parseFloat(syncedQuantity) || 0;
                        const usedQuantity = prevRows
                            .filter(r => r.data.frontendDelete !== 0)
                            .slice(0, rowIndex)
                            .reduce((sum, prevRow) => sum + (parseFloat(prevRow.data.quantity) || 0), 0);
                        const remainingQuantity = totalQuantity - usedQuantity;
                        updatedData.quantity = remainingQuantity > 0 ? remainingQuantity.toString() : '0';
                        if (calculateTotal && updatedData.rate && remainingQuantity > 0) {
                            const rate = parseFloat(updatedData.rate) || 0;
                            const perQty = parseFloat(updatedData.perQuantity) || 1;
                            updatedData.total = (rate * remainingQuantity) / perQty;
                        }
                    }
                } else if (calculateTotal && updatedData.rate && updatedData.quantity) {
                    const rate = parseFloat(updatedData.rate) || 0;
                    const quantity = parseFloat(updatedData.quantity) || 0;
                    const perQty = parseFloat(updatedData.perQuantity) || 1;
                    updatedData.total = (rate * quantity) / perQty;
                }

                return { ...row, data: updatedData };
            })
        );

        setSuggestionsVisibleFor(null);

        // setTimeout(() => {
        //     const currentRow = document.querySelector(`tr:has([data-row-id="${rowId}"])`) ||
        //         Array.from(document.querySelectorAll('tr')).find(tr =>
        //             tr.querySelector(`[data-row-id="${rowId}"]`)
        //         );
        //     if (currentRow) {
        //         const cells = Array.from(currentRow.querySelectorAll('td'));
        //         const currentCell = cells.find(cell =>
        //             cell.querySelector(`input[placeholder="${firstInputPlaceholder}"]`)
        //         );
        //         if (currentCell) {
        //             const currentIndex = cells.indexOf(currentCell);
        //             const nextCell = cells[currentIndex + 1];
        //             if (nextCell) {
        //                 const nextInput = nextCell.querySelector('input');
        //                 const nextDropdown = nextCell.querySelector('[data-dropdown]');
        //                 if (nextDropdown) nextDropdown.focus();
        //                 else if (nextInput) nextInput.focus();
        //             }
        //         }
        //     }
        // }, 50);
        // Table.js mein handleSelectSuggestion ke andar, setSuggestionsVisibleFor(null) ke baad

        setTimeout(() => {
            const allTds = document.querySelectorAll('td');
            let targetRow = null;

            // rowId se targetRow dhundho
            allTds.forEach(td => {
                if (td.getAttribute('data-row-id') === String(rowId)) {
                    targetRow = td.closest('tr');
                }
            });

            // fallback: firstInputPlaceholder wale input se row nikalo
            if (!targetRow) {
                const nameInput = document.querySelector(
                    `input[placeholder="${firstInputPlaceholder}"]`
                );
                if (nameInput) targetRow = nameInput.closest('tr');
            }

            if (!targetRow) return;

            const cells = Array.from(targetRow.querySelectorAll('td'));

            // ✅ KEY FIX: sirf active/visible columns ka index map banao
            // columns prop se visible columns filter karo (active: true wale)
            const activeColumnPlaceholders = new Set(
                columns
                    .filter(col => col && col.active)
                    .map(col => col.placeholder)
            );

            // current cell (name/firstInput wali)
            const currentCell = cells.find(cell =>
                cell.querySelector(`input[placeholder="${firstInputPlaceholder}"]`)
            );

            if (!currentCell) return;

            const currentIndex = cells.indexOf(currentCell);

            // currentIndex ke baad wali cells mein se pehli ACTIVE cell dhundho
            let focusFound = false;
            for (let i = currentIndex + 1; i < cells.length; i++) {
                const cell = cells[i];

                // ✅ Check: kya is cell ka column active hai?
                const input = cell.querySelector('input');
                const dropdown = cell.querySelector('[data-dropdown]');

                if (!input && !dropdown) continue; // koi focusable element nahi

                // Input ka placeholder ya dropdown ka data-placeholder nikalo
                const placeholder = input?.getAttribute('placeholder')
                    || dropdown?.getAttribute('data-placeholder');

                // ✅ Agar column active nahi hai (hide hai), skip karo
                if (placeholder && !activeColumnPlaceholders.has(placeholder)) continue;

                // Active column mila — focus karo
                if (dropdown) {
                    dropdown.focus();
                    // dropdown open mat karo, sirf focus
                } else if (input && !input.disabled && !input.readOnly) {
                    input.focus();
                } else {
                    continue; // disabled/readonly hai, next try karo
                }

                focusFound = true;
                break;
            }

            // Koi active field nahi mili is table mein — next table ya save button pe jao
            if (!focusFound) {
                const currentTable = currentCell.closest('table');
                const allTables = Array.from(document.querySelectorAll('table'));
                const currentTableIndex = allTables.indexOf(currentTable);

                for (let i = currentTableIndex + 1; i < allTables.length; i++) {
                    const table = allTables[i];
                    const firstFocusable = table.querySelector(
                        'input:not([readonly]):not([disabled]), [data-dropdown]'
                    );
                    if (firstFocusable) {
                        firstFocusable.focus();
                        focusFound = true;
                        break;
                    }
                }

                if (!focusFound) {
                    const saveButton = document.querySelector('.save-button, [data-save-button]');
                    if (saveButton) saveButton.focus();
                }
            }
        }, 50);
    }, [
        setRows,
        normalizedLockedFields,
        isMasterTable,
        calculateTotal,
        syncedUnit,
        syncedUnitId,
        syncedRate,
        syncedTotal,
        syncedPerQuantity,
        syncedItemInOut,
        syncedQuantity,
        isEditMode,
        firstInputPlaceholder,
        memoPaymentType
    ]);


    const handleSelectSuggestion = useCallback(
        (rowId, selectedData) => {
            if (selectedData?.__type === "CREATE_LEDGER") {
                const typedValue = getFieldValue(selectedData) || "";
                setRows(prevRows =>
                    prevRows.map(row => {
                        if (row.id !== rowId) return row;
                        return {
                            ...row,
                            data: { ...row.data, [firstInputPlaceholder]: '' }
                        };
                    })
                );
                triggerCreateLedger(typedValue, firstInputPlaceholder, rowId);
                setSuggestionsVisibleFor(null);
                return;
            }

            const base = {
                [firstInputPlaceholder]: getFieldValue(selectedData) || "",
                phone: selectedData?.phone || "",
                cousinName: selectedData?.cousinName || "",
                address: selectedData?.address || "",
                areaId: selectedData?.areaId || "",
                areaName: selectedData?.areaName || "",
                areaPrice: selectedData?.areaPrice || "",
                transportationRate: selectedData?.transportationRate || "",
                ledgerType: selectedData?.ledgerType || selectedData?.groupType || "",
                ledgerId: selectedData?.ledgerId || "",
                ledgerGroup: selectedData?.ledgerGroup || "",
                ledgerSubGroup: selectedData?.ledgerSubGroup || "",
                ledgerSubGroupName: selectedData?.ledgerSubGroupName || "",
                ledgerSubGroupNameInHindi: selectedData?.ledgerSubGroupNameInHindi || "",
                unit: selectedData?.unit || "",
                unitId: selectedData?.unitId || "",
            };

            if (typeof onAreaDataChange === 'function') {
                setTimeout(() => {
                    onAreaDataChange({
                        areaId: base.areaId,
                        areaName: base.areaName,
                        areaPrice: base.areaPrice,
                        transportationRate: base.transportationRate
                    });
                }, 0);
            }

            const currentRow = rows.find((r) => r.id === rowId);
            let cleanData = { ...base };

            if (autoFillRate && areaBasedRate && areaBasedRate.areaPrice) {
                cleanData.rate = areaBasedRate.areaPrice;
                const quantity = currentRow?.data?.quantity || syncedQuantity || "";
                if (quantity) {
                    const qty = parseFloat(quantity) || 0;
                    const rate = parseFloat(areaBasedRate.areaPrice) || 0;
                    const perQty = parseFloat(currentRow?.data?.perQuantity || syncedPerQuantity) || 1;
                    cleanData.total = (qty * rate) / perQty;
                    cleanData.quantity = quantity;
                }
            } else {
                const currentBrickType = norm(currentRow?.data?.typeOfBricks);
                const currentItems = norm(currentRow?.data?.items);
                const baseName = norm(base[firstInputPlaceholder]);

                let allMatchedRecords = [];

                for (let i = 0; i < finalData.length; i++) {
                    const entry = finalData[i];
                    if (!entry) continue;

                    const allRecords = [
                        ...(entry.sales || []),
                        ...(entry.purchase || []),
                        ...(entry.loading || []),
                        ...(entry.fromJournal || []),
                        ...(entry.toJournal || []),
                    ];

                    const matched = allRecords.filter((record) => {
                        const recordName = norm(
                            record?.customer_name || record?.customerName ||
                            record?.vendor || record?.name || ""
                        );
                        if (recordName !== baseName) return false;

                        const recordType = norm(
                            record?.typeOfBricks?.name || record?.type_of_bricks ||
                            record?.items?.name || record?.items || ""
                        );

                        if (currentBrickType && recordType) return recordType === currentBrickType;
                        if (currentItems && recordType) return recordType === currentItems;
                        return true;
                    });

                    if (matched.length > 0) {
                        allMatchedRecords.push(
                            ...matched.map((m) => ({
                                ...m,
                                created_at: new Date(m.created_at || m.createdAt || Date.now())
                            }))
                        );
                    }
                }

                let latestRecord = null;
                if (allMatchedRecords.length > 0) {
                    latestRecord = allMatchedRecords.sort((a, b) => b.created_at - a.created_at)[0];
                }

                if (latestRecord) {
                    const { quantity, total, paid, received, description, ...restData } = latestRecord;
                    cleanData = {
                        ...cleanData,
                        ...restData,
                        [firstInputPlaceholder]: base[firstInputPlaceholder],
                        phone: base.phone || restData.phone || "",
                        cousinName: base.cousinName || restData.cousinName,
                        address: base.address || restData.address,
                        ledgerSubGroupName: base.ledgerSubGroupName || restData.ledgerSubGroupName || restData.sub_group_name || "",
                        ledgerSubGroupNameInHindi: base.ledgerSubGroupNameInHindi || restData.ledgerSubGroupNameInHindi || "",
                        unit: restData.unit || base.unit || "",
                        unitId: restData.unitId || base.unitId || "",
                        ledgerId: base.ledgerId || restData.ledgerId || restData.ledger_id || "",
                        ledgerGroup: base.ledgerGroup || restData.ledgerGroup || restData.ledger_group_id || "",
                        ledgerSubGroup: base.ledgerSubGroup || restData.ledgerSubGroup || restData.ledger_sub_group_id || "",
                        ledgerType: base.ledgerType || restData.ledgerType || restData.groupType || "",
                        total: "",
                        description: "",
                    };
                }
            }

            // finalData se latest history check
            const partyName = norm(base[firstInputPlaceholder] || "");
            const itemName = norm(
                currentRow?.data?.typeOfBricks?.name || currentRow?.data?.items?.name ||
                currentRow?.data?.typeOfBricks || currentRow?.data?.items || ""
            );

            const findLatestHistory = (partyName, itemName, fieldName) => {
                let all = [];
                finalData.forEach(entry => {
                    const allRecords = [
                        ...(entry.sales || []), ...(entry.purchase || []),
                        ...(entry.loading || []), ...(entry.fromJournal || []),
                        ...(entry.toJournal || []),
                    ];
                    const matched = allRecords.filter(record => {
                        const recordName = norm(
                            record?.customer_name || record?.customerName ||
                            record?.vendor || record?.name || ''
                        );
                        const recordItem = norm(
                            fieldName === 'typeOfBricks'
                                ? record?.typeOfBricks?.name || record?.type_of_bricks || ''
                                : record?.items?.name || record?.items || ''
                        );
                        return recordName === partyName && recordItem === itemName;
                    });
                    if (matched.length) {
                        all.push(...matched.map(m => ({
                            ...m,
                            created_at: new Date(m.created_at || m.createdAt)
                        })));
                    }
                });
                if (!all.length) return null;
                return all.sort((a, b) => b.created_at - a.created_at)[0];
            };

            const historyField =
                currentRow?.data?.typeOfBricks ? "typeOfBricks" :
                    currentRow?.data?.items ? "items" : null;

            if (partyName && itemName && historyField) {
                const latest = findLatestHistory(partyName, itemName, historyField);
                if (latest) {
                    cleanData.rate = latest.rate || cleanData.rate || "";
                    cleanData.unit = latest.unit || cleanData.unit || "";
                    cleanData.unitId = latest.unitId || cleanData.unitId || "";
                    cleanData.perQuantity = latest.per_quantity || latest.perQuantity || cleanData.perQuantity || "";
                }
            }

            // ── BACKEND SE LATEST ENTRY FETCH KARO ──
            const ledgerIdToFetch = base.ledgerId;
            // console.log('[debug] ledgerIdToFetch:', ledgerIdToFetch, '| heading:', heading);
            if (ledgerIdToFetch) {
                fetchLatestEntry(ledgerIdToFetch).then((latestEntry) => {
                    let finalCleanData = { ...cleanData };

                    if (latestEntry) {
                        // Backend se aayi values se override karo (sirf agar valid ho)
                        if (latestEntry.rate && parseFloat(latestEntry.rate) > 0) {
                            finalCleanData.rate = latestEntry.rate;
                        }
                        if (latestEntry.unit) {
                            finalCleanData.unit = latestEntry.unit;
                        }
                        if (latestEntry.unit_id || latestEntry.unitId) {
                            finalCleanData.unitId = latestEntry.unit_id || latestEntry.unitId;
                        }
                        if (latestEntry.per_quantity || latestEntry.perQuantity) {
                            finalCleanData.perQuantity = latestEntry.per_quantity || latestEntry.perQuantity;
                        }
                        // if (latestEntry.payment_type || latestEntry.paymentType) {
                        //   finalCleanData.paymentType = latestEntry.payment_type || latestEntry.paymentType;
                        // }
                        if (latestEntry.payment_type && latestEntry.payment_type.id) {
                            finalCleanData.paymentType = {
                                id: latestEntry.payment_type.id,
                                name: latestEntry.payment_type.name || ''
                            };
                        } else {
                            // id null ya missing → default payment type set karo
                            finalCleanData.paymentType = memoPaymentType || "";
                        }
                        if (latestEntry.balance) {
                            finalCleanData.balance = latestEntry.balance;
                        }
                    }

                    applyRowUpdate(rowId, finalCleanData);
                });
            } else {
                applyRowUpdate(rowId, cleanData);
            }
        },
        [
            rows,
            finalData,
            firstInputPlaceholder,
            getFieldValue,
            triggerCreateLedger,
            normalizedLockedFields,
            onAreaDataChange,
            autoFillRate,
            areaBasedRate,
            selectedUnit,
            perQuantityRate,
            syncedQuantity,
            heading,
            calculateTotal,
            isMasterTable,
            isEditMode,
            syncedPerQuantity,
            norm,
            fetchLatestEntry,
            applyRowUpdate,
            memoPaymentType
        ]
    );
    // TableComponent.jsx mein ye useEffect add karo
    useEffect(() => {
        if (!autoFillRate || !areaBasedRate?.areaPrice) return;

        setRows(prevRows =>
            prevRows.map(row => {
                if (row.data.frontendDelete === 0) return row;

                const rate = parseFloat(areaBasedRate.areaPrice) || 0;
                const quantity = parseFloat(row.data.quantity || syncedQuantity) || 0;
                const perQty = parseFloat(row.data.perQuantity || syncedPerQuantity) || 1;
                const total = rate && quantity ? (rate * quantity) / perQty : '';

                return {
                    ...row,
                    data: {
                        ...row.data,
                        rate: areaBasedRate.areaPrice,
                        total: total || '',
                        areaId: areaBasedRate.areaId || row.data.areaId || '',
                        areaName: areaBasedRate.areaName || row.data.areaName || '',
                        areaPrice: areaBasedRate.areaPrice,
                        transportationRate: areaBasedRate.areaPrice,
                    }
                };
            })
        );
    }, [areaBasedRate?.areaPrice, areaBasedRate?.areaId]);
    useEffect(() => {
        if (!autoFillRate) return;
        if (areaBasedRate?.areaPrice) return; // sirf empty hone pe

        setRows(prevRows =>
            prevRows.map(row => {
                if (row.data.frontendDelete === 0) return row;
                return {
                    ...row,
                    data: {
                        ...row.data,
                        rate: '',
                        total: '',
                        areaId: '',
                        areaName: '',
                        areaPrice: '',
                        transportationRate: '',
                    }
                };
            })
        );
    }, [autoFillRate, areaBasedRate?.areaPrice]);

    useEffect(() => {
        if (!calculateTotal) return;

        setRows(prevRows =>
            prevRows.map(row => {
                if (!row || !row.data) return row;

                if (row.data._totalModified) return row;

                if (isEditMode && row.data._isFromDatabase && row.data._originalTotal) {
                    const rateChanged = row.data._rateModified;
                    const quantityChanged = row.data._quantityModified;

                    if (!rateChanged && !quantityChanged) {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                total: row.data._originalTotal
                            }
                        };
                    }
                }

                const rate = parseFloat(row.data.rate) || 0;
                const quantity = parseFloat(row.data.quantity) || 0;
                const perQty = parseFloat(
                    row.data.perQuantity ||
                    row.data.per_quantity ||
                    syncedPerQuantity ||
                    1
                );

                if (rate && quantity) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            total: (rate * quantity) / perQty,
                            perQuantity: perQty.toString(),
                            per_quantity: perQty.toString()
                        }
                    };
                }

                return row;
            })
        );
    }, [
        calculateTotal,
        syncedPerQuantity,
        isEditMode,
        rows.map(r =>
            r && r.data
                ? `${r.data.rate}-${r.data.quantity}-${r.data.perQuantity || r.data.per_quantity}-${r.data._totalModified}`
                : ''
        ).join(',')
    ]);


    const openAddOptionModal = useCallback((placeholder) => {
        setModalPlaceholder(placeholder);
        setNewOptionText('');
        setModalVisible(true);
        setOpenDropdown(null);
    }, []);

    const addRow = useCallback(() => {
        if (!isMasterTable && syncedQuantity) {
            const totalQuantity = parseFloat(syncedQuantity) || 0;
            const usedQuantity = rows
                .filter(row => row.data.frontendDelete !== 0)
                .reduce((sum, row) => {
                    if (row && row.data) {
                        return sum + (parseFloat(row.data.quantity) || 0);
                    }
                    return sum;
                }, 0);
            const remainingQuantity = totalQuantity - usedQuantity;

            if (remainingQuantity <= 0) {
                if (showValidationError) {
                    showValidationError('Cannot add more rows. Total quantity already distributed!');
                }
                return;
            }
        }

        setRows(prev => {
            const newRowData = createEmptyRow();
            const lastRowData = prev[prev.length - 1]?.data;

            if (defaultPaymentType && !newRowData.paymentType) {
                newRowData.paymentType = {
                    id: defaultPaymentType.ledgerId,
                    name: defaultPaymentType.name
                };
            }

            if (normalizedLockedFields) {
                Object.keys(normalizedLockedFields).forEach(key => {
                    if (normalizedLockedFields[key]) {
                        newRowData[key] = normalizedLockedFields[key];
                    }
                });
            }

            if (lastRowData) {
                const fieldsToCarry = ['ledgerId', 'ledgerGroup', 'ledgerSubGroup'];
                fieldsToCarry.forEach(f => {
                    if (!newRowData[f] && lastRowData[f]) {
                        newRowData[f] = lastRowData[f];
                    }
                });

                if (isMasterTable) {
                    if (lastRowData.typeOfBricks) {
                        newRowData.typeOfBricks = lastRowData.typeOfBricks;
                    }
                    if (lastRowData.items) {
                        newRowData.items = lastRowData.items;
                    }
                    if (lastRowData.unit) {
                        newRowData.unit = lastRowData.unit;
                    }
                    if (lastRowData.perQuantity) {
                        newRowData.perQuantity = lastRowData.perQuantity;
                    }
                    if (lastRowData.rate) {
                        newRowData.rate = lastRowData.rate;
                    }
                }
            }

            if (!isMasterTable) {
                if (syncedItem) {
                    newRowData.typeOfBricks = syncedItem;
                    newRowData.items = syncedItem;
                }

                if (syncedQuantity) {
                    const totalQuantity = parseFloat(syncedQuantity) || 0;
                    const usedQuantity = prev
                        .filter(row => row.data.frontendDelete !== 0)
                        .reduce((sum, row) => {
                            if (row && row.data) {
                                return sum + (parseFloat(row.data.quantity) || 0);
                            }
                            return sum;
                        }, 0);
                    const remainingQuantity = totalQuantity - usedQuantity;
                    newRowData.quantity = remainingQuantity > 0 ? remainingQuantity.toString() : '0';
                }

                if (syncedUnit) {
                    newRowData.unit = syncedUnit;
                }
                if (syncedUnitId) {
                    newRowData.unitId = syncedUnitId;
                }
                if (syncedPerQuantity) {
                    newRowData.perQuantity = syncedPerQuantity;
                }
                if (syncedRate) {
                    newRowData.rate = syncedRate;
                }
                if (syncedTotal) {
                    newRowData.total = syncedTotal;
                }
                if (syncedItemInOut) {
                    newRowData.itemInOut = syncedItemInOut;
                }
            }

            const newRow = {
                id: (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`),
                data: newRowData
            };
            return [...prev, newRow];
        });
    }, [createEmptyRow, normalizedLockedFields, isMasterTable, defaultPaymentType, syncedItem, syncedQuantity, syncedUnit, syncedUnitId, syncedPerQuantity, syncedRate, syncedTotal, syncedItemInOut, showValidationError, rows]);

    const removeRow = useCallback((id) => {
        if (isEditMode) {
            // Mark as deleted in edit mode
            setRows(prev => {
                const updated = prev.map(row =>
                    row.id === id
                        ? { ...row, data: { ...row.data, frontendDelete: 0 } }
                        : row
                );

                //  CRITICAL: Trigger parent callback after state update
                setTimeout(() => {
                    if (isMasterTable && onItemChange) {
                        // Calculate new total from remaining active rows
                        const activeRows = updated.filter(r => r.data.frontendDelete !== 0);
                        if (activeRows.length > 0) {
                            const firstRow = activeRows[0];
                            const currentItem = firstRow.data.typeOfBricks || firstRow.data.items;
                            const totalQuantity = activeRows.reduce(
                                (sum, row) => sum + (parseFloat(row.data.quantity) || 0),
                                0
                            );

                            onItemChange(
                                currentItem,
                                totalQuantity.toString(),
                                firstRow.data.unit,
                                firstRow.data.unitId,
                                firstRow.data.itemInOut,
                                firstRow.data.rate,
                                firstRow.data.total,
                                firstRow.data.perQuantity
                            );
                        }
                    }
                }, 0);

                return updated;
            });
        } else {
            // Actually remove in create mode
            setRows(prev => prev.filter(row => row.id !== id));
        }
    }, [isEditMode, isMasterTable, onItemChange]);

    //  NEW: Trigger onItemChange when rows are deleted in master table
    useEffect(() => {
        if (!isMasterTable || !onItemChange) return;

        const activeRows = rows.filter(row => row.data.frontendDelete !== 0);

        if (activeRows.length === 0) return;

        const firstRow = activeRows[0];
        const currentItem = firstRow.data.typeOfBricks || firstRow.data.items;

        if (!currentItem) return;

        // Calculate total quantity excluding deleted rows
        const totalQuantity = activeRows.reduce(
            (sum, row) => sum + (parseFloat(row.data.quantity) || 0),
            0
        );

        // Trigger parent callback to update transportation/loading tables
        onItemChange(
            currentItem,
            totalQuantity.toString(),
            firstRow.data.unit,
            firstRow.data.unitId,
            firstRow.data.itemInOut,
            firstRow.data.rate,
            firstRow.data.total,
            firstRow.data.perQuantity
        );
    }, [
        // Track number of active rows and their total quantity
        rows.filter(r => r.data.frontendDelete !== 0).length,
        rows.filter(r => r.data.frontendDelete !== 0).reduce((sum, r) => sum + (parseFloat(r.data.quantity) || 0), 0),
        isMasterTable,
        onItemChange
    ]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setSuggestionsVisibleFor(null);
                setOpenDropdown(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const groupForInput = columnLedgerGroups[firstInputPlaceholder] || defaultLedgerGroup;

    useEffect(() => {
        if (!suggestionsVisibleFor) return;

        const rowId = suggestionsVisibleFor;

        const ledgerSuggestions = backendLedgers.map((ldg) => ({
            source: "ledger",
            [field]: getFieldValue(ldg) || "",
            phone: ldg?.phone || "",
            cousinName: ldg?.cousinName || "",
            address: ldg?.address || "",
            areaId: ldg?.area_id || ldg?.areaId || "",
            areaName: ldg?.area_name || ldg?.areaName || "",
            areaPrice: ldg?.area_price || ldg?.areaPrice || "",          // ← area_price backend se
            transportationRate: ldg?.area_price || ldg?.transportationRate || "",
            ledgerId: ldg?.id || ldg?.ledgerId || "",
            ledgerType: ldg?.groupType || "",
            ledgerGroup: ldg?.groupId || "",
            ledgerSubGroup: ldg?.subGroupId || "",
            ledgerSubGroupName: ldg?.subGroupName || "",
            ledgerSubGroupNameInHindi: ldg?.subGroupNameInHindi || "",
            unit: ldg?.unitName || ldg?.unit || "",
            unitId: ldg?.unitId || "",
        }));

        const combined = [
            {
                __type: "CREATE_LEDGER",
                label: t("createALedger"),
                [field]: currentSearchValue,
                phone: '',
                address: '',
                cousinName: '',
                ledgerSubGroupName: "",
                ledgerSubGroupNameInHindi: "",
                group: groupForInput
            },
            ...ledgerSuggestions,
        ];

        setFilteredSuggestionsByRow(prev => ({ ...prev, [rowId]: combined }));
        setHighlightIndexes(prev => ({
            ...prev,
            [rowId]: combined.length > 1 ? 1 : 0
        }));
        setKeyboardHighlightIndexes(prev => ({
            ...prev,
            [rowId]: combined.length > 1 ? 1 : 0
        }));
    }, [backendLedgers, suggestionsVisibleFor, currentSearchValue, field, groupForInput, t]);
    useEffect(() => {
        if (!suggestionsVisibleFor) return;
        const idx = keyboardHighlightIndexes[suggestionsVisibleFor];
        if (idx === undefined || idx < 0) return;
        const key = `${suggestionsVisibleFor}_${idx}`;

        requestAnimationFrame(() => {
            const el = suggestionRefs.current[key];
            if (el) {
                el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }
        });
    }, [keyboardHighlightIndexes, suggestionsVisibleFor]);

    const handleLedgerUpdate = useCallback(async () => {
        try {
            await onUpdateData?.();

            const groupsRes = await api.get(`groups-types/get-all-group?branchId=${branchId}`);
            if (groupsRes.data.success) {
                setAllGroups(groupsRes.data.allData || []);
            }

            const subGroupsRes = await api.get(`groups-types/get-all-sub-group?branchId=${branchId}`);
            if (subGroupsRes.data.success) {
                setAllSubGroups(subGroupsRes.data.allData || []);
            }

            setTimeout(() => {
                if (tableContainerRef.current) {
                    tableContainerRef.current.style.filter = 'none';
                    tableContainerRef.current.style.pointerEvents = 'auto';
                }

                if (lastFocusedElementRef.current && lastFocusedElementRef.current.focus) {
                    lastFocusedElementRef.current.focus();
                    lastFocusedElementRef.current = null;
                } else {
                    const firstInput = document.querySelector('table input:not([readonly]):not([disabled])');
                    if (firstInput) {
                        firstInput.focus();
                    }
                }
            }, 100);

        } catch (error) {
            console.error("Failed to refresh data:", error);
        }
    }, [onUpdateData, branchId]);

    const handleModalCancel = useCallback(() => {
        setModalVisible(false);

        setTimeout(() => {
            if (tableContainerRef.current) {
                tableContainerRef.current.style.filter = 'none';
                tableContainerRef.current.style.pointerEvents = 'auto';
            }

            if (lastFocusedElementRef.current && lastFocusedElementRef.current.focus) {
                lastFocusedElementRef.current.focus();
                lastFocusedElementRef.current = null;
            } else {
                const firstInput = document.querySelector('table input:not([readonly]):not([disabled])');
                if (firstInput) {
                    firstInput.focus();
                }
            }
        }, 100);
    }, []);

    useEffect(() => {
        filterData();
    }, [ledgerData]);

    const calculateSuggestionPosition = (inputElement) => {
        if (!inputElement) return;

        const updatePosition = () => {
            const rect = inputElement.getBoundingClientRect();

            if (rect.width === 0 || rect.height === 0) {
                return false;
            }

            const modalContainer = inputElement.closest('.overflow-y-auto');
            const scrollOffset = modalContainer ? modalContainer.scrollTop : 0;

            setSuggestionPosition({
                top: rect.bottom + window.scrollY - scrollOffset,
                left: rect.left + window.scrollX,
                width: rect.width
            });

            return true;
        };

        if (!updatePosition()) {
            requestAnimationFrame(() => {
                if (!updatePosition()) {
                    setTimeout(updatePosition, 100);
                }
            });
        }
    };

    const filterableColumnsKey = useMemo(() => {
        return columns
            .filter(col => col && col.filteration && col.uniqueId)
            .map(col => col.uniqueId)
            .join(',');
    }, [columns]);
    const allGroupsKey = useMemo(() =>
        allGroups.map(g => g.id || g.groupId).filter(Boolean).join(','),
        [allGroups]
    );

    const allSubGroupsKey = useMemo(() =>
        allSubGroups.map(sg => sg.id || sg.subGroupId).filter(Boolean).join(','),
        [allSubGroups]
    );

    useEffect(() => {
        if (!branchId || !tableUniqueId || filterInserted) return;

        if (!allGroups || allGroups.length === 0) return;
        if (!allSubGroups || allSubGroups.length === 0) return;
        const filterableColumns = columns.filter(col => col && col.filteration && col.uniqueId);
        if (filterableColumns.length === 0) return;


        const insertAllFilters = async () => {
            try {
                await Promise.all(
                    filterableColumns.map(col => {
                        let groupIds;
                        let subGroupIds;

                        if (col.columnPart) {
                            // Sirf us type ke groups/subgroups filter karo
                            const matchedGroups = allGroups.filter(g =>
                                g.type?.toLowerCase() === col.columnPart.toLowerCase()
                            );
                            const matchedGroupNames = new Set(matchedGroups.map(g => g.groupName));

                            groupIds = matchedGroups.map(g => g.id || g.groupId).filter(Boolean);
                            subGroupIds = allSubGroups
                                .filter(sg => matchedGroupNames.has(sg.groupName))
                                .map(sg => sg.id || sg.subGroupId)
                                .filter(Boolean);
                        } else {
                            // columnPart nahi → sab pass karo
                            groupIds = allGroups.map(g => g.id || g.groupId).filter(Boolean);
                            subGroupIds = allSubGroups.map(sg => sg.id || sg.subGroupId).filter(Boolean);
                        }

                        return api.post('/column-filter/add-filter-value', {
                            branchId,
                            tableName: tableUniqueId,
                            columnName: col.uniqueId,
                            groupIds,
                            subGroupIds
                        });
                    })
                );
                setFilterInserted(true);
            } catch (err) {
                console.error('[TableComponent] insertAllFilters error:', err);
            }
        };
        insertAllFilters();
    }, [branchId, tableUniqueId, allGroupsKey, allSubGroupsKey, filterableColumnsKey]);

    const fetchAllColumnFilters = useCallback(async () => {
        if (!branchId || !tableUniqueId) return;

        const filterableCols = columns.filter(col => col && col.filteration && col.uniqueId);
        if (filterableCols.length === 0) return;

        const results = await Promise.all(
            filterableCols.map(col =>
                api.get('/column-filter/get-filter-value', {
                    params: { branchId, tableName: tableUniqueId, columnName: col.uniqueId }
                })
                    .then(res => ({ uniqueId: col.uniqueId, data: res?.data?.data }))
                    .catch(() => ({ uniqueId: col.uniqueId, data: null }))
            )
        );

        const map = {};
        results.forEach(({ uniqueId, data }) => {
            map[uniqueId] = {
                groupIds: data?.groupIds || [],
                subGroupIds: data?.subGroupIds || [],
                hasRecord: !!data
            };
        });
        setColumnFilterMap(map);

        //  columns ki jagah filterableColumnsKey use karo dependency mein
    }, [branchId, tableUniqueId, filterableColumnsKey, filterVersion]);

    useEffect(() => {
        fetchAllColumnFilters();
    }, [fetchAllColumnFilters]);

    return (
        <>
            <div className={`  mb-1 `} ref={wrapperRef}>
                {heading && (
                    <div className='flex justify-between '>
                        <div className={` w-40  rounded-top-1 flex bg-theme-headerBg  text-theme-headerText ${createDyanamicAccount ? "justify-between" : "justify-center"} px-1 pt-[1px]`}>
                            <div className="  font-medium text-sm py-[2px] ">
                                {createDyanamicAccount && selectedDynamicAccount ? selectedDynamicAccount.name : heading}
                            </div>
                            {createDyanamicAccount && (
                                <div className='pt-[1px] relative' ref={dynamicAccountRef}>
                                    <div
                                        className='border rounded-1 p-[3px] cursor-pointer hover:text-theme-headerBg hover:bg-theme-color flex items-center gap-1'
                                        title='Select Account'
                                        onClick={() => setDynamicAccountDropdownOpen(!dynamicAccountDropdownOpen)}
                                    >
                                        <FaChevronDown className={`text-xs transform transition-transform duration-200 ${dynamicAccountDropdownOpen ? 'rotate-180' : 'rotate-0'
                                            }`} />
                                    </div>

                                </div>
                            )}
                        </div>

                    </div>
                )}

                <table className="w-full  border border-gray-100 bg-theme-tableBg table-fixed mb-0 relative  border-separate border-spacing-0 " ref={tableContainerRef}>
                    <thead>
                        <tr>
                            {columns
                                .filter(
                                    col =>
                                        !col.combined || col.placeholder === 'name' || col.placeholder === 'customerName' || col.placeholder === 'vendor' || col.placeholder === 'rate'
                                )
                                .map((column, idx) => (
                                    <th
                                        key={idx}
                                        className="px-1  font-medium overflow-hidden text-gray-700 capitalize text-sm"
                                        style={{
                                            width:
                                                column.placeholder === "customerName"
                                                    ? "200px"
                                                    : column.placeholder === "name"
                                                        ? "200px"
                                                        : column.placeholder === "vendor"
                                                            ? "200px"
                                                            : column.placeholder === "rate"
                                                                ? "135px"
                                                                : column.placeholder === "unit"
                                                                    ? "95px"
                                                                    : "auto"
                                        }}
                                    >
                                        <div className="flex items-center justify-between">
                                            <div className="px-1 overflow-hidden mt-1">
                                                <ContactMarquee tableColumn={column.header} />
                                            </div>

                                            {column.filteration && (
                                                <div
                                                    className="font-bold cursor-pointer text-lg border-1   mt-1 rounded-1 py-[2px] hover:bg-theme-dropdownHeqadibg hover:text-theme-sidebarTabBg px-1 ms-auto"
                                                    title="filter search value"
                                                    onClick={() => {
                                                        setIsModalOpen(true);
                                                        setAddFilterationValue(true)
                                                        setUniqueFilter(column.inputType === "input" ? "text_type" : "dropdown_type");
                                                        setFetchDatabyFilter(column.header);
                                                        setColumnUniqueId(column.uniqueId)
                                                        if (column.columnPart) {
                                                            setAllowedGroupTypes([column.columnPart]); // e.g. ["Stock"]
                                                        } else if (column.placeholder === "typeOfBricks" || column.placeholder === "items") {
                                                            setAllowedGroupTypes(["Stock"]);
                                                        } else if (column.placeholder === "paymentType") {
                                                            setAllowedGroupTypes(["Assets"]);
                                                        } else {
                                                            setAllowedGroupTypes(["Assets", "Expense", "Income", "Liability"]);
                                                        }
                                                    }}
                                                >
                                                    <RiMenuSearchLine />
                                                </div>
                                            )}
                                            {column.showUnit && (
                                                <div className='mt-1'>{syncedUnit && `(${syncedUnit})`}</div>
                                            )}

                                        </div>
                                    </th>
                                ))}

                            {allowMultiple && (
                                <th className="px-1  font-medium text-gray-700 capitalize w-16 text-sm">
                                    {t('actions')}
                                </th>
                            )}
                        </tr>
                    </thead>

                    <tbody className="bg-theme-tableBg ">
                        {/*  FILTER OUT DELETED ROWS */}
                        {rows
                            .filter(row => row.data.frontendDelete !== 0)
                            .map((row, rowIndex) => (
                                <tr key={row.id} className="relative ">

                                    {(() => {
                                        const combinedCols = columns.filter(c => c.combined);
                                        const normalCols = columns.filter(c => !c.combined);

                                        if (combinedCols.length > 0) {
                                            const firstCol = combinedCols[0];
                                            const nameVal = row.data[firstCol.placeholder] ?? '';
                                            const addressCol = combinedCols.find(c => c.placeholder === 'address');
                                            const phoneCol = combinedCols.find(c => c.placeholder === 'phone');
                                            const addressVal = row.data[addressCol?.placeholder] ?? '';
                                            const phoneVal = row.data[phoneCol?.placeholder] ?? '';
                                            const cousinVal = row.data.cousinName
                                            const ledgerSubGroupName = row.data.ledgerSubGroupName
                                            const ledgerSubGroupNameInHindi = row.data.ledgerSubGroupNameInHindi
                                            const suggestionsForThisRow = filteredSuggestionsByRow[row.id] || [];
                                            const hIndex = highlightIndexes[row.id] ?? -1;

                                            return (
                                                <>
                                                    <td key="combined-col" className="  p-1 text-gray-700 relative align-top " >
                                                        <div className="flex flex-col text-left">
                                                            <input
                                                                type="text"
                                                                value={typeof nameVal === 'object' ? nameVal.name ?? '' : nameVal}
                                                                onChange={e => handleInputChange(row.id, firstCol.placeholder, e.target.value)}
                                                                onClick={() => {
                                                                    setAddFilterationValue(true)
                                                                    if (firstCol.filteration) {
                                                                        setUniqueFilter(firstCol.inputType === "input" ? "text_type" : "dropdown_type");
                                                                    }
                                                                }}
                                                                placeholder={firstCol.placeholder}
                                                                className="w-full px-2 border outline-slate-300    bg-theme-inputBg     "
                                                                autoComplete="off"
                                                                onFocus={(e) => {
                                                                    setAddFilterationValue(true)
                                                                    setFetchDatabyFilter(firstCol.header);
                                                                    if (firstCol.filteration) {
                                                                        setUniqueFilter(firstCol.inputType === "input" ? "text_type" : "dropdown_type");
                                                                        setColumnUniqueId(firstCol.uniqueId);
                                                                    } else {
                                                                        setUniqueFilter("text_type");
                                                                        setColumnUniqueId(firstCol.uniqueId);
                                                                    }
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (!suggestionsForThisRow.length) return;

                                                                    if (e.key === "ArrowDown") {
                                                                        e.preventDefault();
                                                                        setHighlightIndexes(prev => {
                                                                            const cur = prev[row.id];
                                                                            const startIndex = suggestionsForThisRow.length === 1 ? 0 : 1;
                                                                            const current = (cur === undefined || cur === -1) ? startIndex : cur;
                                                                            // Last item pe ruko, wrap mat karo
                                                                            const next = current < suggestionsForThisRow.length - 1 ? current + 1 : current;
                                                                            return { ...prev, [row.id]: next };
                                                                        });
                                                                        setKeyboardHighlightIndexes(prev => {
                                                                            const cur = prev[row.id];
                                                                            const startIndex = suggestionsForThisRow.length === 1 ? 0 : 1;
                                                                            const current = (cur === undefined || cur === -1) ? startIndex : cur;
                                                                            const next = current < suggestionsForThisRow.length - 1 ? current + 1 : current;
                                                                            return { ...prev, [row.id]: next };
                                                                        });
                                                                        setHoverIndex(prev => ({ ...prev, [row.id]: -1 }));

                                                                    } else if (e.key === "ArrowUp") {
                                                                        e.preventDefault();
                                                                        setHighlightIndexes(prev => {
                                                                            const cur = prev[row.id];
                                                                            if (cur === undefined || cur === -1) {
                                                                                return { ...prev, [row.id]: 0 };
                                                                            }
                                                                            const next = cur > 0 ? cur - 1 : 0;
                                                                            return { ...prev, [row.id]: next };
                                                                        });
                                                                        setKeyboardHighlightIndexes(prev => {
                                                                            const cur = prev[row.id];
                                                                            if (cur === undefined || cur === -1) {
                                                                                return { ...prev, [row.id]: 0 };
                                                                            }
                                                                            const next = cur > 0 ? cur - 1 : 0;
                                                                            return { ...prev, [row.id]: next };
                                                                        });
                                                                        setHoverIndex(prev => ({ ...prev, [row.id]: -1 }));

                                                                    } else if (e.key === "Enter") {
                                                                        e.preventDefault();
                                                                        const keyboardIndex = keyboardHighlightIndexes[row.id];
                                                                        const highlightIndex = highlightIndexes[row.id];
                                                                        const effectiveIndex =
                                                                            (keyboardIndex !== undefined && keyboardIndex >= 0)
                                                                                ? keyboardIndex
                                                                                : (highlightIndex !== undefined && highlightIndex >= 0)
                                                                                    ? highlightIndex
                                                                                    : suggestionsForThisRow.length > 1 ? 1 : 0;

                                                                        const selected = suggestionsForThisRow[effectiveIndex];
                                                                        if (selected) {
                                                                            if (selected.__type === "CREATE_LEDGER") {
                                                                                triggerCreateLedger(selected, firstInputPlaceholder, row.id);
                                                                            } else {
                                                                                handleSelectSuggestion(row.id, selected);
                                                                            }
                                                                        }
                                                                        setSuggestionsVisibleFor(null);
                                                                        setKeyboardHighlightIndexes(prev => ({ ...prev, [row.id]: -1 }));
                                                                        setHighlightIndexes(prev => ({ ...prev, [row.id]: -1 }));
                                                                    }
                                                                    else if (e.key === "Escape") {
                                                                        setSuggestionsVisibleFor(null);
                                                                        setKeyboardHighlightIndexes(prev => ({ ...prev, [row.id]: -1 }));
                                                                        setHighlightIndexes(prev => ({ ...prev, [row.id]: -1 }));
                                                                        const currentCell = e.target.closest('td');
                                                                        const row = currentCell.closest('tr');
                                                                        const cells = Array.from(row.querySelectorAll('td'));
                                                                        const currentIndex = cells.indexOf(currentCell);
                                                                        const prevCell = cells[currentIndex - 1];

                                                                        if (prevCell) {
                                                                            const prevInput = prevCell.querySelector('input');
                                                                            if (prevInput) {
                                                                                prevInput.focus();
                                                                            }
                                                                        }
                                                                    } else if (e.key === "Tab") {
                                                                        e.preventDefault();
                                                                        const currentCell = e.target.closest('td');
                                                                        const currentRow = currentCell.closest('tr');
                                                                        const allRows = Array.from(currentRow.closest('tbody').querySelectorAll('tr'));
                                                                        const currentRowIndex = allRows.indexOf(currentRow);
                                                                        const cells = Array.from(currentRow.querySelectorAll('td'));
                                                                        const currentIndex = cells.indexOf(currentCell);
                                                                        const nextCell = cells[currentIndex + 1];

                                                                        if (nextCell) {
                                                                            const nextInput = nextCell.querySelector('input');
                                                                            const nextDropdown = nextCell.querySelector('[data-dropdown]');

                                                                            if (nextDropdown) {
                                                                                const nextPlaceholder = nextDropdown.getAttribute('data-placeholder');
                                                                                setOpenDropdown({ rowId: currentRow.id, placeholder: nextPlaceholder });
                                                                            } else if (nextInput) {
                                                                                nextInput.focus();
                                                                            }
                                                                        } else {
                                                                            const nextRow = allRows[currentRowIndex + 1];
                                                                            if (nextRow) {
                                                                                const firstInput = nextRow.querySelector('input');
                                                                                if (firstInput) {
                                                                                    firstInput.focus();
                                                                                }
                                                                            } else {
                                                                                const saveButton = document.querySelector('[data-save-button], button[type="submit"], .save-btn');
                                                                                if (saveButton) {
                                                                                    saveButton.focus();
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }}
                                                            />

                                                            <div ref={suggestionWrapperRef} className="relative">
                                                                {suggestionsVisibleFor === row.id && (
                                                                    <ul
                                                                        className="fixed bg-theme-sidebarTabBg shadow-lg border border-gray-300 rounded-1 max-h-60 overflow-auto p-0"
                                                                        style={{
                                                                            zIndex: 999,
                                                                            minWidth: "300px"
                                                                        }}
                                                                    >

                                                                        {suggestionsForThisRow.map((sug, i) => (
                                                                            <li
                                                                                key={i}
                                                                                ref={(el) => { suggestionRefs.current[`${row.id}_${i}`] = el; }}

                                                                                className={`py-1 cursor-pointer text-center text-sm ${(highlightIndexes[row.id] === i)
                                                                                    ? 'bg-theme-dropdownHeqadibg text-theme-color'
                                                                                    : 'hover:bg-theme-tableHoverColor hover:text-black'
                                                                                    } ${sug.__type === "CREATE_LEDGER" ? `${(highlightIndexes[row.id] === i || hoverIndex[row.id] === i)
                                                                                        ? "text-theme-color"
                                                                                        : "text-theme-headerBg"
                                                                                        } bg-theme-color font-semibold` : ''}`}
                                                                                onMouseDown={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    if (sug.__type === "CREATE_LEDGER") {
                                                                                        triggerCreateLedger(sug, firstInputPlaceholder, row.id);
                                                                                    } else {
                                                                                        handleSelectSuggestion(row.id, sug);
                                                                                    }
                                                                                    setSuggestionsVisibleFor(null);
                                                                                    setKeyboardHighlightIndexes(prev => ({ ...prev, [row.id]: -1 }));
                                                                                    setHighlightIndexes(prev => ({ ...prev, [row.id]: -1 }));

                                                                                }}
                                                                                onMouseEnter={() => {

                                                                                    setHoverIndex(prev => ({ ...prev, [row.id]: i }));
                                                                                    // 
                                                                                }}
                                                                                onMouseLeave={() => {

                                                                                    setHoverIndex(prev => ({ ...prev, [row.id]: -1 }));
                                                                                }}
                                                                            >
                                                                                {sug.__type === "CREATE_LEDGER" ? (
                                                                                    sug.label
                                                                                ) : (
                                                                                    <>
                                                                                        <div className='flex gap-3 justify-center'>
                                                                                            <div className='flex justify-start gap-2 font-medium capitalize w-full'>
                                                                                                <ContactMarquee
                                                                                                    firstName={sug[field] || sug.name || sug.customerName || sug.companyName || sug.vendor || sug.driverName || sug.vehicleName}
                                                                                                    secondName={sug.cousinName}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='flex justify-center'>
                                                                                            <div className='flex gap-3 justify-center capitalize w-full'>
                                                                                                <ContactMarquee
                                                                                                    firstName={sug.ledgerSubGroupName}
                                                                                                    secondName={sug.ledgerSubGroupNameInHindi}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="flex justify-center">
                                                                                            <div className='flex justify-center gap-2 w-full'>
                                                                                                <ContactMarquee
                                                                                                    phoneVal={sug.phone && sug.phone}
                                                                                                    addressVal={sug.address && sug.address}
                                                                                                    cousinName={''}
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                    </>
                                                                                )}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>

                                                            <ContactMarquee phoneVal={phoneVal} addressVal={addressVal} cousinName={cousinVal} ledgerSubGroupName={ledgerSubGroupName} ledgerSubGroupNameInHindi={ledgerSubGroupNameInHindi} />
                                                            {row.data.balance && (
                                                                <div className="flex mt-[2px]">
                                                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
Bal: ₹ {Number(row.data.balance.closing_balance).toLocaleString('en-IN')} {row.data.balance.closing_balance !== 0 && `(${row.data.balance.closing_balance_type})`}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {normalCols.map((column, colIndex) => {
                                                        const isDropdown = column.inputType === 'dropdown';
                                                        const rawVal = row.data[column.placeholder] ?? '';
                                                        const isLockedField = column.locked && normalizedLockedFields && rowIndex > 0;
                                                        const displayValue = isLockedField ? (normalizedLockedFields[column.placeholder] ?? rawVal) : rawVal;
                                                        let finalDisplayValue = displayValue;

                                                        if (
                                                            isDropdown &&
                                                            column.placeholder === 'paymentType' &&
                                                            (!displayValue || displayValue === '') &&
                                                            defaultPaymentType
                                                        ) {

                                                            finalDisplayValue = memoPaymentType;
                                                        }

                                                        if (isDropdown) {
                                                            const groupForColumn = columnLedgerGroups[column.placeholder] || defaultLedgerGroup;

                                                            return (
                                                                <td key={colIndex} className="py-1 px-1  relative " data-row-id={row.id} data-placeholder={column.placeholder}>
                                                                    <CustomDropdown
                                                                        rowId={row.id}
                                                                        placeholder={column.placeholder}
                                                                        selectedValue={finalDisplayValue}
                                                                        onChange={val => handleInputChange(row.id, column.placeholder, val)}
                                                                        column={column}
                                                                        ledgerData={allLedgers}
                                                                        allPaymentData={allPaymentData}
                                                                        openDropdown={openDropdown}
                                                                        setOpenDropdown={setOpenDropdown}
                                                                        openAddOptionModal={openAddOptionModal}
                                                                        suggestionsData={rows}
                                                                        selectedGroups={selectedGroups}
                                                                        selectedSubGroups={selectedSubGroups}
                                                                        heading={heading}
                                                                        setFetchDatabyFilter={setFetchDatabyFilter}
                                                                        defaultLedgerGroup={groupForColumn}
                                                                        onCreateLedgerFromDropdown={(payload) =>
                                                                            triggerCreateLedger(payload, column.placeholder, row.id)
                                                                        }
                                                                        setDropDownOpen={setDropDownOpen}
                                                                        dropDownOpen={dropDownOpen}
                                                                        tableFilters={tableFilters}
                                                                        setUniqueFilter={setUniqueFilter}
                                                                        setAddFilterationValue={setAddFilterationValue}
                                                                        uniqueForFilter={uniqueForFilter}
                                                                        onAddNewPayment={() => setIsAddPaymentModalOpen(true)}
                                                                        externalGroupIds={columnFilterMap[column.uniqueId]?.groupIds || []}
                                                                        externalSubGroupIds={columnFilterMap[column.uniqueId]?.subGroupIds || []}
                                                                        hasExternalFilter={columnFilterMap[column.uniqueId]?.hasRecord ?? false}

                                                                    />
                                                                    <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none">
                                                                        <FaChevronDown className={`text-[12px] text-gray-400 transform transition-transform duration-300 ease-in-out ${dropDownOpen ? 'rotate-180' : 'rotate-0'
                                                                            }`} />
                                                                    </div>
                                                                </td>
                                                            );
                                                        }

                                                        return (
                                                            <td key={colIndex} className="py-1 px-1  ">
                                                                <input
                                                                    ref={rowIndex === 0 && colIndex === 0 ? firstInputRef : null}
                                                                    type={column.type === 'number' ? 'text' : 'text'}
                                                                    inputMode={column.type === 'number' ? 'decimal' : 'text'}
                                                                    value={typeof displayValue === 'object' ? displayValue.name ?? '' : displayValue}
                                                                    onKeyPress={(e) => {
                                                                        if (column.type === 'number') {
                                                                            const char = e.key;
                                                                            const currentValue = e.target.value;

                                                                            const isNumber = /[0-9]/.test(char);
                                                                            const isDecimal = char === '.';
                                                                            const isMinus = char === '-';
                                                                            const isControl = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char);

                                                                            if (isDecimal && currentValue.includes('.')) {
                                                                                e.preventDefault();
                                                                                return;
                                                                            }

                                                                            if (isMinus && currentValue.length > 0) {
                                                                                e.preventDefault();
                                                                                return;
                                                                            }

                                                                            if (!isNumber && !isDecimal && !isMinus && !isControl) {
                                                                                e.preventDefault();
                                                                                if (showValidationError) {
                                                                                    showValidationError('Only numbers are allowed in this field');
                                                                                }
                                                                                return;
                                                                            }
                                                                        }
                                                                    }}
                                                                    onChange={e => {
                                                                        let value = e.target.value;

                                                                        if (column.type === 'number') {
                                                                            value = value.replace(/[^0-9.-]/g, '');

                                                                            const parts = value.split('.');
                                                                            if (parts.length > 2) {
                                                                                value = parts[0] + '.' + parts.slice(1).join('');
                                                                            }

                                                                            if (value.indexOf('-') > 0) {
                                                                                value = value.replace(/-/g, '');
                                                                            }
                                                                        }

                                                                        handleInputChange(row.id, column.placeholder, value);
                                                                    }}
                                                                    placeholder={column.placeholder}
                                                                    onFocus={() => setFetchDatabyFilter(column.header)}
                                                                    className={`w-full px-2 border   outline-slate-300 ${isLockedField || column.readOnly ? 'bg-gray-100 cursor-not-allowed' : 'bg-theme-inputBg'}`}
                                                                    readOnly={isLockedField || column.readOnly}
                                                                    disabled={isLockedField || column.readOnly}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            const currentCell = e.target.closest('td');
                                                                            const row = currentCell.closest('tr');
                                                                            const cells = Array.from(row.querySelectorAll('td'));
                                                                            const currentIndex = cells.indexOf(currentCell);
                                                                            const nextCell = cells[currentIndex + 1];
                                                                            if (nextCell) {
                                                                                const nextInput = nextCell.querySelector('input');
                                                                                const nextDropdown = nextCell.querySelector('[data-dropdown]');
                                                                                if (nextDropdown) {
                                                                                    const nextPlaceholder = nextDropdown.getAttribute('data-placeholder');
                                                                                    nextDropdown.focus();
                                                                                    setTimeout(() => {
                                                                                        setOpenDropdown({ rowId: row.id, placeholder: nextPlaceholder });
                                                                                    }, 10);
                                                                                } else if (nextInput) {
                                                                                    nextInput.focus();
                                                                                } else {
                                                                                    let foundNextInput = false;
                                                                                    for (let i = currentIndex + 1; i < cells.length; i++) {
                                                                                        const cell = cells[i];
                                                                                        const input = cell.querySelector('input');
                                                                                        const dropdown = cell.querySelector('[data-dropdown]');
                                                                                        if (input || dropdown) {
                                                                                            foundNextInput = true;
                                                                                            if (dropdown) {
                                                                                                const placeholder = dropdown.getAttribute('data-placeholder');
                                                                                                dropdown.focus();
                                                                                                setTimeout(() => {
                                                                                                    setOpenDropdown({ rowId: row.id, placeholder });
                                                                                                }, 10);
                                                                                            } else {
                                                                                                input.focus();
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                    }

                                                                                    if (!foundNextInput) {
                                                                                        const currentTable = currentCell.closest('table');
                                                                                        const allTables = Array.from(document.querySelectorAll('table'));
                                                                                        const currentTableIndex = allTables.indexOf(currentTable);
                                                                                        let nextTableWithInput = null;

                                                                                        for (let i = currentTableIndex + 1; i < allTables.length; i++) {
                                                                                            const table = allTables[i];
                                                                                            const hasInputs = table.querySelector('input:not([readonly]):not([disabled]), [data-dropdown]');
                                                                                            if (hasInputs) {
                                                                                                nextTableWithInput = table;
                                                                                                break;
                                                                                            }
                                                                                        }

                                                                                        if (nextTableWithInput) {
                                                                                            const firstInput = nextTableWithInput.querySelector('input:not([readonly]):not([disabled]), [data-dropdown]');
                                                                                            if (firstInput) {
                                                                                                firstInput.focus();
                                                                                                if (firstInput.hasAttribute('data-dropdown')) {
                                                                                                    const rowId = firstInput.getAttribute('data-row-id');
                                                                                                    const placeholder = firstInput.getAttribute('data-placeholder');
                                                                                                    setTimeout(() => setOpenDropdown({ rowId, placeholder }), 10);
                                                                                                }
                                                                                            }
                                                                                        } else {
                                                                                            const saveButton =
                                                                                                heading === "Pay"
                                                                                                    ? document.querySelector('#payment-save-btn, .payment-save-button')
                                                                                                    : heading === "Receive"
                                                                                                        ? document.querySelector('#receipt-save-btn, .receipt-save-button')
                                                                                                        : document.querySelector('.save-button, [data-save-button]');

                                                                                            if (saveButton) {
                                                                                                saveButton.focus();
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                const currentTable = currentCell.closest('table');
                                                                                const allTables = Array.from(document.querySelectorAll('table'));
                                                                                const currentTableIndex = allTables.indexOf(currentTable);
                                                                                let nextTableWithInput = null;

                                                                                for (let i = currentTableIndex + 1; i < allTables.length; i++) {
                                                                                    const table = allTables[i];
                                                                                    const hasInputs = table.querySelector('input:not([readonly]):not([disabled]), [data-dropdown]');
                                                                                    if (hasInputs) {
                                                                                        nextTableWithInput = table;
                                                                                        break;
                                                                                    }
                                                                                }

                                                                                if (nextTableWithInput) {
                                                                                    const firstInput = nextTableWithInput.querySelector('input:not([readonly]):not([disabled]), [data-dropdown]');
                                                                                    if (firstInput) {
                                                                                        firstInput.focus();
                                                                                        if (firstInput.hasAttribute('data-dropdown')) {
                                                                                            const rowId = firstInput.getAttribute('data-row-id');
                                                                                            const placeholder = firstInput.getAttribute('data-placeholder');
                                                                                            setTimeout(() => setOpenDropdown({ rowId, placeholder }), 10);
                                                                                        }
                                                                                    }
                                                                                } else {
                                                                                    const saveButton =
                                                                                        heading === t('payment')
                                                                                            ? document.querySelector('#payment-save-btn, .payment-save-button')
                                                                                            : heading === t("Receive")
                                                                                                ? document.querySelector('#receipt-save-btn, .receipt-save-button')
                                                                                                : document.querySelector('.save-button, [data-save-button]');

                                                                                    if (saveButton) {
                                                                                        saveButton.focus();
                                                                                    }
                                                                                }
                                                                            }
                                                                        } else if (e.key === 'Escape') {
                                                                            const currentCell = e.target.closest('td');
                                                                            const row = currentCell.closest('tr');
                                                                            const cells = Array.from(row.querySelectorAll('td'));
                                                                            const currentIndex = cells.indexOf(currentCell);
                                                                            const prevCell = cells[currentIndex - 1];

                                                                            if (prevCell) {
                                                                                const prevInput = prevCell.querySelector('input');
                                                                                if (prevInput) {
                                                                                    prevInput.focus();
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            </td>
                                                        );
                                                    })}
                                                </>
                                            );
                                        }
                                    })()}

                                    {allowMultiple && (
                                        <td className="py-1 px-1   text-center">
                                            <div className="flex gap-1 justify-center " >
                                                {/* ✅ Only show delete button for non-deleted rows */}
                                                {rows.filter(r => r.data.frontendDelete !== 0).length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => removeRow(row.id)}
                                                        className="border-1 border-gray-500 text-gray-500 rounded-1 hover:bg-gray-500 hover:text-theme-color hover:test-theme-headerBg   p-0 fw-bold rounded h-6 w-7"
                                                        title="Remove data entry"
                                                    >
                                                        <div className='relative xl:top-[-2px]'>
                                                            &times;
                                                        </div>
                                                    </button>
                                                )}
                                                {rowIndex === rows.filter(r => r.data.frontendDelete !== 0).length - 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={addRow}
                                                        className="border-1 border-theme-headerBg text-theme-headerBg rounded-1 hover:bg-theme-headerBg hover:text-theme-color hover:test-theme-headerBg   p-0 fw-bold rounded h-6 w-7"
                                                        title="add new data entry"
                                                    >
                                                        <div className='relative md:top-[-3.5px] font-bold text-[18px]'>
                                                            +
                                                        </div>
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            {modalVisible && (
                <div
                    className="fixed inset-0 bg-black/20 bg-opacity-40 flex justify-center items-center z-[999]"
                >
                    <div
                        className="rounded max-w-4xl text-start max-h-[70vh] w-full shadow-lg overflow-y-auto custom-scrollbar"
                    >
                        <CreateLedger
                            setModalVisible={(val) => {
                                if (val === false) {
                                    handleModalCancel();
                                }
                            }}
                            onUpdateData={async () => {
                                await handleLedgerUpdate();
                                // setModalVisible(false);
                            }}
                            groupData={() => axios.get(`${API_BASE}groups-types/get-all-group`)}
                            subGroupData={() => axios.get(`${API_BASE}groups-types/get-all-sub-group`)}
                            initialData={createLedgerInitData}
                            addMoreBtn={false}
                            manageStock={createLedgerInitData?.group === "Bricks" || createLedgerInitData?.group === "Raw Material"}
                            allGroups={allGroups}
                            allSubGroups={allSubGroups}
                            setAllGroups={setAllGroups}
                            setAllSubGroups={setAllSubGroups}
                            isEdit={false}
                        />
                    </div>
                </div>
            )}

            {isModalOpen && (
                <FilterModal
                    heading={heading}
                    tableUniqueId={tableUniqueId}
                    columnUniqueId={columnUniqueId}
                    uniqueFilter={uniqueFilter}
                    groupedData={groupedData}
                    allowedGroupTypes={allowedGroupTypes}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    setAddFilterationValue={setAddFilterationValue}
                    addFilterationValue={addFilterationValue}
                    selectedGroups={selectedGroups}
                    setSelectedGroups={setSelectedGroups}
                    selectedSubGroups={selectedSubGroups}
                    setSelectedSubGroups={setSelectedSubGroups}
                    onUpdate={handleFilterUpdate}
                    uniqueForFilter={uniqueForFilter}
                />
            )}

            {isModalOpenRateUnit && (
                <div className="fixed inset-0 bg-black bg-opacity-50  flex justify-center items-center z-[9999]">
                    <div className="bg-white p-4 rounded shadow-md w-[350px] ">
                        <div className="font-semibold mb-2">Select Number Of Bricks</div>

                        {["1 ", "1000"]
                            .map((unit) => (
                                <div key={unit} className="flex items-center gap-2 mb-1">
                                    <input
                                        type="checkbox"
                                        checked={selectedUnit === unit}
                                        onChange={() => {
                                            setSelectedUnit(unit);
                                            localStorage.setItem(`${heading}_${part || "part"}_selectedUnit`, unit);
                                            setIsModalOpenRateUnit(false);
                                        }}
                                    />
                                    <span>{unit} Qty </span>
                                </div>
                            ))}

                        <div className='text-end'>
                            <button
                                className="mt-3 px-3 py-1 bg-gray-300 rounded"
                                onClick={() => setIsModalOpenRateUnit(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {tableFilterModalOpen && (
                <div className="fixed inset-0 bg-black/15 bg-opacity-50  flex justify-center items-center z-[9999]">
                    <TableFilterModal
                        tableFilters={tableFilters}
                        isOpen={tableFilterModalOpen}
                        onClose={() => setTableFilterModalOpen(false)}
                        heading={heading}
                        onSave={(filters) => setTableFilters(filters)}
                    />
                </div>
            )}

            {isAddPaymentModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[1000]">
                    <AddPayment
                        name={paymentName}
                        nameInHindi={paymentNameInHindi}
                        setNameInHindi={setPaymentNameInHindi}
                        setName={setPaymentName}
                        subGroupValidation={paymentSubGroupValidation}
                        groupName={paymentGroupName}
                        setGroupName={setPaymentGroupName}
                        groupId={paymentGroupId}
                        setGroupId={setPaymentGroupId}
                        selectGroupValidation={paymentSelectGroupValidation}
                        setSelectGroupValidation={setPaymentSelectGroupValidation}
                        groupType={paymentGroupType}
                        setGroupType={setPaymentGroupType}
                        handleGroupSelect={() => { }}
                        handleSubGroupCancel={() => {
                            setIsAddPaymentModalOpen(false);
                            setPaymentName("");
                            setPaymentNameInHindi("");
                            setPaymentType("");
                            setPaymentGroupName("");
                            setPaymentGroupId("");
                            setPaymentSubGroup("");
                            setPaymentLedger("");
                            setPaymentGroupType("");
                            setPaymentSubGroupId("");
                            setPaymentLedgerId("");
                            setPaymentTypeValidation(false);
                            setPaymentSubGroupValidation(false);
                            setPaymentSelectGroupValidation(false);
                        }}
                        handleSave={async (childData) => {
                            const finalLedgerId = childData?.ledgerId || paymentLedgerId;
                            if (!paymentType) {
                                setPaymentTypeValidation(true);
                                toast.error("Please select type");
                                return;
                            }
                            if (!paymentGroupName) {
                                setPaymentSelectGroupValidation(true);
                                setPaymentTypeValidation(false);
                                toast.error("Please select group");
                                return;
                            }
                            if (!finalLedgerId) {
                                setPaymentSelectGroupValidation(false);
                                setPaymentTypeValidation(false);
                                toast.error("Please select ledger");
                                return;
                            }
                            if (!paymentName) {
                                setPaymentSubGroupValidation(true);
                                setPaymentSelectGroupValidation(false);
                                setPaymentTypeValidation(false);
                                toast.error("Please enter payment name");
                                return;
                            }

                            try {
                                const payload = {
                                    name: paymentName,
                                    nameInHindi: paymentNameInHindi,
                                    type: paymentType,
                                    groupId: paymentGroupId,
                                    subGroupId: paymentSubGroupId || null,
                                    ledgerId: finalLedgerId || null,
                                    branchId
                                };

                                const res = await api.post(`payment-structure/create`, payload);

                                if (res.data.success) {
                                    toast.success("Payment structure added successfully!");

                                    if (onUpdateData) {
                                        await onUpdateData();
                                    }
                                    if (updatePaymentAccount) {
                                        await updatePaymentAccount();
                                    }

                                    setIsAddPaymentModalOpen(false);
                                    setPaymentName("");
                                    setPaymentNameInHindi("");
                                    setPaymentType("");
                                    setPaymentGroupName("");
                                    setPaymentGroupId("");
                                    setPaymentSubGroup("");
                                    setPaymentLedger("");
                                    setPaymentGroupType("");
                                    setPaymentSubGroupId("");
                                    setPaymentLedgerId("");
                                    setPaymentTypeValidation(false);
                                    setPaymentSubGroupValidation(false);
                                    setPaymentSelectGroupValidation(false);
                                }
                            } catch (error) {
                                console.error("Payment save error:", error);
                                toast.error(error?.response?.data?.message || "Failed to save payment structure");
                            }
                        }}
                        loading={false}
                        setLoading={() => { }}
                        selectedType={paymentType}
                        setSelectedType={setPaymentType}
                        selectedSubGroup={paymentSubGroup}
                        setSelectedSubGroup={setPaymentSubGroup}
                        selectedLedger={paymentLedger}
                        setSelectedLedger={setPaymentLedger}
                        typeValidation={paymentTypeValidation}
                        onDataRefresh={handlePaymentDataRefresh}
                    />
                </div>
            )}
        </>
    );
};

export default TableComponent;